import React, { useCallback, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getIndexColorLighter, ID3v2FromBlob, validFramesIds, ycBucket } from '../../../common/Tool';
import { CollectionPartialReplacementProvider, CollectionServer, CREATE, deleteInArray, deleteInProperties, DropdownAction, errorCatch, Field, foreachInProperties, GET, GetMetaProperties, getObjectDisplay, JSX, JSXMap, makeFormData, Model, POST, POSTFormData, QueryDetail, QueryOrder, QueryParam, SetMetaProperties, UPDATE, updateArrayInArray, updateInArray, updateInProperties, updateInPropertiesUUID, useAuth, useMetaContext, useTranslateContext, useUserConfigContext, useUserContext, ycStorage } from 'fennec-ui';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { Button, Progress, Spin, Tabs, Tooltip } from 'antd';
import PageLayout from '../../components/PageLayout';
import { useEffect } from 'react';
import { useRef } from 'react';
import Icofont from 'react-icofont';
import confirmKey from '../../components/ConfirmKeyModal';
import "./index.css";
import YAudioImage from '../../../common/YAudioImage';
import AudioProperties from './AudioProperties';
import ObjectOwnerDescription from '../../../fedance-ui/ObjectOwnerDescription';

import { AudioPlayerProvider, useAudioPlayerContext } from '../../../common/AudioPlayer/context/audio-player-context';
import { AudioPlayer } from '../../../common/AudioPlayer/components/AudioPlayer';
import { Card } from 'antd';
import { Empty } from 'antd';
import { Alert } from 'antd';
import FilterFieldLabel from '../../components/FilterFieldLabel';

// import esPkg from 'essentia.js';
// const essentia = new esPkg.Essentia(esPkg.EssentiaWASM.EssentiaWASM);

var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');
var _ = require('lodash');

function Trek(props) {
    const { auth, item, idx, modelActions, collection, setCollection, style, className } = props;

    const {
        tracks,
        setTracks,
        currentTrack,
        setCurrentTrack,
        audioRef,
        progressBarRef,
        timeProgress,
        setTimeProgress,
        duration,
        setDuration,
        setTrackIndex,
        isPlaying,
        setIsPlaying,
    } = useAudioPlayerContext();

    const play = () => {
        if (currentTrack?.ID === item?.ID && isPlaying) {
            setIsPlaying(false);
        } else {
            setCurrentTrack(item);
            setIsPlaying(true);
        }
    };

    return (
        <div key={idx} className={className} style={{ ...style, display: "flex", alignItems: "center", gap: "10px", marginBottom: "2px", textAlign: "left" }}>
            <div onClick={play}>
                <YAudioImage
                    playing={currentTrack?.ID === item?.ID && isPlaying}
                    error={false}
                    width={55}
                    image={item.picture}
                    minimage={item.picture}
                    hidePreview={true}
                    imageStyle={{ borderRadius: "4px", border: "1px solid #ebebeb", borderRadius: "4px" }}
                />
            </div>
            <div style={{ flex: "1 1 auto" }}>
                <div style={{ fontWeight: "bold" }}>
                    {item.nazvanieTreka}
                </div>
                <div style={{ fontWeight: "normal", fontSize: "12px", color: "rgba(0,0,0,0.65)", display: "flex", gap: "10px" }}>
                    {item?.sozdateliTrekaTrek && <div>
                        {JSXMap(item.sozdateliTrekaTrek, (sitem, idx) => {
                            return (<span key={idx}>{(idx > 0) ? ", " : ""}{sitem?.sozdatel?.familiya} {sitem?.sozdatel?.imya}{(sitem?.sozdatel?.psevdonim) ? " (" + sitem?.sozdatel?.psevdonim + ")" : ""}</span>)
                        })}
                    </div>}
                </div>
                <div style={{ display: "flex", gap: "3px" }}>
                    <Tooltip title={`Темп${(item?.temp) ? " - " + item?.temp : ""}`}>
                        <div className="border-grey" style={{ width: "55px", alignSelf: "center", backgroundColor: (item?.temp) ? getIndexColorLighter(0, 0.15) : "#f2f2f2", borderRadius: "12px", padding: "0 8px", fontSize: "10px", textAlign: "center" }}>
                            {item?.temp && <div style={{ display: "flex", gap: "2px", alignItems: "center", justifyContent: "center" }}><div></div>{item?.temp} <div style={{ fontSize: "9px" }}>bpm</div></div>}
                            {!item?.temp && <span> - <span style={{ fontSize: "9px" }}></span></span>}
                        </div>
                    </Tooltip>
                    <Tooltip title={`Длительность вступления${(item?.dlitelnostVstupleniyaSek) ? " - " + item?.dlitelnostVstupleniyaSek : ""}`}>
                        <div className="border-grey" style={{ width: "45px", alignSelf: "center", backgroundColor: (item?.dlitelnostVstupleniyaSek) ? getIndexColorLighter(1, 0.15) : "#f2f2f2", borderRadius: "12px", padding: "0 8px", fontSize: "10px", textAlign: "center" }}>
                            {item?.dlitelnostVstupleniyaSek && <div style={{ display: "flex", gap: "3px", alignItems: "center", justifyContent: "center" }}><div><i className="fa fa-long-arrow-right"></i></div>{item?.dlitelnostVstupleniyaSek} <div style={{ fontSize: "9px" }}></div></div>}
                            {!item?.dlitelnostVstupleniyaSek && <span> - <span style={{ fontSize: "9px" }}></span></span>}
                        </div>
                    </Tooltip>
                    <Tooltip title={`Хитовость трека${(item?.khitovostTreka) ? " - " + item?.khitovostTreka : ""}`}>
                        <div className="border-grey" style={{ width: "45px", alignSelf: "center", backgroundColor: (item?.khitovostTreka) ? getIndexColorLighter(3, 0.15) : "#f2f2f2", borderRadius: "12px", padding: "0 8px", fontSize: "10px", textAlign: "center" }}>
                            {item?.khitovostTreka && <div style={{ display: "flex", gap: "3px", alignItems: "center", justifyContent: "center" }}><div><i className="fa fa-star-o"></i></div>{item?.khitovostTreka} <div style={{ fontSize: "9px" }}></div></div>}
                            {!item?.khitovostTreka && <span> - <span style={{ fontSize: "9px" }}></span></span>}
                        </div>
                    </Tooltip>
                    <Tooltip title={`Сложность трека${(item?.slozhnostTreka) ? " - " + item?.slozhnostTreka : ""}`}>
                        <div className="border-grey" style={{ width: "45px", alignSelf: "center", backgroundColor: (item?.slozhnostTreka) ? getIndexColorLighter(4, 0.15) : "#f2f2f2", borderRadius: "12px", padding: "0 8px", fontSize: "10px", textAlign: "center" }}>
                            {item?.slozhnostTreka && <div style={{ display: "flex", gap: "3px", alignItems: "center", justifyContent: "center" }}><div><i className="fa fa-lightbulb-o"></i></div>{item?.slozhnostTreka} <div style={{ fontSize: "9px" }}></div></div>}
                            {!item?.slozhnostTreka && <span> - <span style={{ fontSize: "9px" }}></span></span>}
                        </div>
                    </Tooltip>
                    <Tooltip title={`Количество сбивок за полторы минуты${(item?.kolichestvoAktsentovZaPoltoriMinuti) ? " - " + item?.kolichestvoAktsentovZaPoltoriMinuti : ""}`}>
                        <div className="border-grey" style={{ width: "45px", alignSelf: "center", backgroundColor: (item?.kolichestvoAktsentovZaPoltoriMinuti) ? getIndexColorLighter(5, 0.15) : "#f2f2f2", borderRadius: "12px", padding: "0 8px", fontSize: "10px", textAlign: "center" }}>
                            {item?.kolichestvoAktsentovZaPoltoriMinuti && <div style={{ display: "flex", gap: "3px", alignItems: "center", justifyContent: "center" }}><div><i className="fa fa-hourglass-start" style={{ fontSize: "8px" }}></i></div>{item?.kolichestvoAktsentovZaPoltoriMinuti} <div style={{ fontSize: "9px" }}></div></div>}
                            {!item?.kolichestvoAktsentovZaPoltoriMinuti && <span> - <span style={{ fontSize: "9px" }}></span></span>}
                        </div>
                    </Tooltip>
                    <Tooltip title={`Количество сбивок за две минуты${(item?.kolichestvoAktsentovZaDveMinuti) ? " - " + item?.kolichestvoAktsentovZaDveMinuti : ""}`}>
                        <div className="border-grey" style={{ width: "45px", alignSelf: "center", backgroundColor: (item?.kolichestvoAktsentovZaDveMinuti) ? getIndexColorLighter(6, 0.15) : "#f2f2f2", borderRadius: "12px", padding: "0 8px", fontSize: "10px", textAlign: "center" }}>
                            {item?.kolichestvoAktsentovZaDveMinuti && <div style={{ display: "flex", gap: "3px", alignItems: "center", justifyContent: "center" }}><div><i className="fa fa-hourglass-half" style={{ fontSize: "8px" }}></i></div>{item?.kolichestvoAktsentovZaDveMinuti} <div style={{ fontSize: "9px" }}></div></div>}
                            {!item?.kolichestvoAktsentovZaDveMinuti && <span> - <span style={{ fontSize: "9px" }}></span></span>}
                        </div>
                    </Tooltip>
                    <Tooltip title={`Кол-во смен ритмов бачаты${(item?.kolvoSmenRitmovBachati) ? " - " + item?.kolvoSmenRitmovBachati : ""}`}>
                        <div className="border-grey" style={{ width: "45px", alignSelf: "center", backgroundColor: (item?.kolvoSmenRitmovBachati) ? getIndexColorLighter(7, 0.15) : "#f2f2f2", borderRadius: "12px", padding: "0 8px", fontSize: "10px", textAlign: "center" }}>
                            {item?.kolvoSmenRitmovBachati && <div style={{ display: "flex", gap: "3px", alignItems: "center", justifyContent: "center" }}><div><i className="fa fa-level-up"></i></div>{item?.kolvoSmenRitmovBachati} <div style={{ fontSize: "9px" }}></div></div>}
                            {!item?.kolvoSmenRitmovBachati && <span> - <span style={{ fontSize: "9px" }}></span></span>}
                        </div>
                    </Tooltip>
                    <Tooltip title={`Количество акцентов за две минуты${(item?.kolvoObigrishei) ? " - " + item?.kolvoObigrishei : ""}`}>
                        <div className="border-grey" style={{ width: "45px", alignSelf: "center", backgroundColor: (item?.kolvoObigrishei) ? getIndexColorLighter(8, 0.15) : "#f2f2f2", borderRadius: "12px", padding: "0 8px", fontSize: "10px", textAlign: "center" }}>
                            {item?.kolvoObigrishei && <div style={{ display: "flex", gap: "3px", alignItems: "center", justifyContent: "center" }}><div><i className="fa fa-retweet"></i></div>{item?.kolvoObigrishei} <div style={{ fontSize: "9px" }}></div></div>}
                            {!item?.kolvoObigrishei && <span> - <span style={{ fontSize: "9px" }}></span></span>}
                        </div>
                    </Tooltip>
                    <Tooltip title={`Энергетика${(item?.energetika) ? " - " + item?.energetika?.nazvanie : ""}`}>
                        <div className="border-grey" style={{ width: "90px", alignSelf: "center", backgroundColor: (item?.energetika) ? getIndexColorLighter(2, 0.15) : "#f2f2f2", borderRadius: "12px", padding: "0 8px", fontSize: "10px", overflow: "hidden", textWrap: "nowrap", textOverflow: "ellipsis", textAlign: "center" }}>
                            {item?.energetika && <div style={{ display: "flex", gap: "3px", alignItems: "center", justifyContent: "center" }}><div><i className="fa fa-bolt"></i></div>{item?.energetika?.nazvanie.slice(0, 11)} <div style={{ fontSize: "9px" }}></div></div>}
                            {!item?.energetika && <span> - <span style={{ fontSize: "9px" }}></span></span>}
                        </div>
                    </Tooltip>

                </div>
                {/* <div>
                    <AudioPlayer
                        ref={playerRef}
                        className="custom-audio-player"
                        src={ycStorage(auth) + ycBucket(auth) + "/" + item?.src}
                        onPlay={onPlay}
                        onPause={onPause}
                        onEnd={onEnd}
                        onError={onError}
                    />
                </div> */}
            </div>
            {(modelActions(item, idx)?.length) && <div style={{ flex: "0 0 25px" }}>
                <DropdownAction
                    style={{ padding: "0" }}
                    button={() => (<div className={`pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                        <i className="fa fa-ellipsis-h"></i>
                    </div>)}
                    items={modelActions(item, idx)?.map((e, idx) => ({
                        key: e.key || idx,
                        auth: auth,
                        mode: "MenuItem",
                        object: item,
                        collection: collection,
                        setCollection: setCollection,
                        ...e
                    }))} />
            </div>}
        </div>
    )
}
function RaspredelenieCell(props) {
    const { key, auth, distsiplinaID, item, idx, modelActions, collection, setCollection, style, className, slozhnostProp, turIDProp, colorProp, lightProp } = props;
    const [loading, setLoading] = useState(false);
    const create = useCallback((slozhnost, turID, val) => {
        let values = {
            trekID: item.ID,
            distsiplinaID: distsiplinaID,
            slozhnost: slozhnost,
            turID: turID,
            poryadkoviiNomerVTure: val
        }

        setLoading(true);
        POST(auth, "/api/raspredeleniepokategoriyam/new", values, ({ data }) => {
            setCollection((o) => updateInArray(o, { ...item, raspredeleniePoKategoriyamTrek: updateInArray(item?.raspredeleniePoKategoriyamTrek, data) }));
            setLoading(false);
        }, (err) => errorCatch(err, () => setLoading(false)));
    }, [item, slozhnostProp, turIDProp])
    const update = useCallback((id, slozhnost, turID, val) => {
        let values = {
            ID: id,
            trekID: item.ID,
            distsiplinaID: distsiplinaID,
            slozhnost: slozhnost,
            turID: turID,
            poryadkoviiNomerVTure: val
        }
        setLoading(true);
        POST(auth, "/api/raspredeleniepokategoriyam/update", values, ({ data }) => {
            setCollection((o) => updateInArray(o, { ...item, raspredeleniePoKategoriyamTrek: updateInArray(item?.raspredeleniePoKategoriyamTrek, data) }));
            setLoading(false);
        }, (err) => errorCatch(err, () => setLoading(false)));
    }, [item, slozhnostProp, turIDProp])

    const remove = useCallback((obj) => {
        setLoading(true);
        GET(auth, `/api/raspredeleniepokategoriyam/delete/${obj?.ID}`, ({ data }) => {
            setCollection((o) => updateInArray(o, { ...item, raspredeleniePoKategoriyamTrek: deleteInArray(item?.raspredeleniePoKategoriyamTrek, obj) }));
            setLoading(false);
        }, (err) => errorCatch(err, () => setLoading(false)));
    }, [item, slozhnostProp, turIDProp])

    const removeCurrentValue = useCallback((slozhnost, turID) => {
        if (loading) return;

        let obj = getCurrentValueObject(slozhnost, turID);
        if (obj) {
            return remove(obj)
        }
    }, [item, slozhnostProp, turIDProp, loading])

    const setCurrentValue = useCallback((slozhnost, turID) => {
        if (loading) return;

        let obj = getCurrentValueObject(slozhnost, turID);
        let val = (obj?.poryadkoviiNomerVTure !== undefined && obj?.poryadkoviiNomerVTure !== null) ? obj?.poryadkoviiNomerVTure : -1;
        let pack = [-1, 1, 2, 3, 4, 5, 0]

        let idx = pack.indexOf(val) + 1;
        let v = _.get(pack, `[${Math.abs(idx) % pack.length}]`)

        if (!obj) {
            return create(slozhnost, turID, v)
        } else if (v >= 0) {
            return update(obj?.ID, slozhnost, turID, v)
        } else {
            return remove(obj)
        }
    }, [item, slozhnostProp, turIDProp, loading])

    const getCurrentValueObject = useCallback((slozhnost, turID) => {
        let o = item?.raspredeleniePoKategoriyamTrek?.find(e => e.slozhnost === slozhnost && e.turID === turID && e.trekID === item.ID && e.distsiplinaID === distsiplinaID)
        return o
    }, [item, slozhnostProp, turIDProp])
    const renderCurrentValue = useCallback((slozhnost, turID) => {
        let o = getCurrentValueObject(slozhnost, turID)
        if (o?.poryadkoviiNomerVTure === 0) {
            return <span style={{ fontSize: "16px", fontWeight: "bold" }}><i className="fa fa-check"></i></span>
        } else if (o?.poryadkoviiNomerVTure > -1) {
            return <span style={{ fontSize: "16px", fontWeight: "bold" }}>{o?.poryadkoviiNomerVTure}</span>
        } else {
            return <span style={{}}>-</span>
        }
        // return (o?.poryadkoviiNomerVTure > -1) ? <span style={{ fontSize: "16px", fontWeight: "bold" }}>{o?.poryadkoviiNomerVTure}</span> : "-"
    }, [item, slozhnostProp, turIDProp])

    return (
        <td className={"height-8"} style={{ width: "34px", minWidth: "34px" }}>

            <div onClick={(e) => e.ctrlKey ? removeCurrentValue(slozhnostProp, turIDProp) : setCurrentValue(slozhnostProp, turIDProp)} className="bg bg-orange border-transparent pointer" style={{ minWidth: "34px", height: "100%", padding: "0px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: (!getCurrentValueObject(slozhnostProp, turIDProp)) ? getIndexColorLighter(colorProp, lightProp) : "#f5f5f5" }}>
                <Spin spinning={loading}>
                    <div style={{ overflow: "hidden", textWrap: "nowrap", textOverflow: "ellipsis", textAlign: "center" }}>
                        {renderCurrentValue(slozhnostProp, turIDProp)}
                    </div>
                </Spin>
            </div>

        </td>
    )
}
function TrekPoKategoriyam(props) {
    const { auth, distsiplinaID, item, idx, modelActions, collection, setCollection, style, className } = props;
    const {
        tracks,
        setTracks,
        currentTrack,
        setCurrentTrack,
        audioRef,
        progressBarRef,
        timeProgress,
        setTimeProgress,
        duration,
        setDuration,
        setTrackIndex,
        isPlaying,
        setIsPlaying,
    } = useAudioPlayerContext();

    const play = () => {
        if (currentTrack?.ID === item?.ID && isPlaying) {
            setIsPlaying(false);
        } else {
            setCurrentTrack(item);
            setIsPlaying(true);
        }
    };

    return (
        <tr className={className} style={{ lineHeight: "1.5" }}>
            <td className={`fixed ${(item?.usluga?.kategoriya) ? "height-8" : "height-6"}`} style={{ minWidth: "561px", maxWidth: "561px", backgroundColor: "white" }}>
                <div key={idx} className={className} style={{ ...style, display: "flex", minWidth: "561px", maxWidth: "561px", alignItems: "center", gap: "10px", marginBottom: "2px", textAlign: "left", paddingRight: "3px" }}>
                    <div onClick={play}>
                        <YAudioImage
                            playing={currentTrack?.ID === item?.ID && isPlaying}
                            error={false}
                            width={55}
                            image={item.picture}
                            minimage={item.picture}
                            hidePreview={true}
                            imageStyle={{ borderRadius: "4px", border: "1px solid #ebebeb", borderRadius: "4px" }}
                        />
                    </div>
                    <div style={{ flex: "1 1 auto" }}>
                        <div style={{ fontWeight: "bold", overflow: "hidden", textWrap: "nowrap", textOverflow: "ellipsis" }}>
                            {item.nazvanieTreka}
                        </div>
                        <div style={{ fontWeight: "normal", fontSize: "12px", maxWidth: "492px", color: "rgba(0,0,0,0.65)", overflow: "hidden", textWrap: "nowrap", textOverflow: "ellipsis" }}>
                            {item?.sozdateliTrekaTrek && <React.Fragment>
                                {JSXMap(item.sozdateliTrekaTrek, (sitem, idx) => {
                                    return (<span key={idx}>{(idx > 0) ? ", " : ""}{sitem?.sozdatel?.familiya} {sitem?.sozdatel?.imya}{(sitem?.sozdatel?.psevdonim) ? " (" + sitem?.sozdatel?.psevdonim + ")" : ""}</span>)
                                })}
                            </React.Fragment>}
                        </div>
                        <div style={{ display: "flex", gap: "3px" }}>
                            <Tooltip title={`Темп${(item?.temp) ? " - " + item?.temp : ""}`}>
                                <div className="border-grey" style={{ width: "55px", alignSelf: "center", backgroundColor: (item?.temp) ? getIndexColorLighter(0, 0.15) : "#f2f2f2", borderRadius: "12px", padding: "0 8px", fontSize: "10px", textAlign: "center" }}>
                                    {item?.temp && <div style={{ display: "flex", gap: "2px", alignItems: "center", justifyContent: "center" }}><div>{item?.temp}</div><div style={{ fontSize: "9px" }}>bpm</div></div>}
                                    {!item?.temp && <span> - <span style={{ fontSize: "9px" }}></span></span>}
                                </div>
                            </Tooltip>
                            <Tooltip title={`Длительность вступления${(item?.dlitelnostVstupleniyaSek) ? " - " + item?.dlitelnostVstupleniyaSek : ""}`}>
                                <div className="border-grey" style={{ width: "45px", alignSelf: "center", backgroundColor: (item?.dlitelnostVstupleniyaSek) ? getIndexColorLighter(1, 0.15) : "#f2f2f2", borderRadius: "12px", padding: "0 8px", fontSize: "10px", textAlign: "center" }}>
                                    {item?.dlitelnostVstupleniyaSek && <div style={{ display: "flex", gap: "3px", alignItems: "center", justifyContent: "center" }}><div><i className="fa fa-long-arrow-right"></i> {item?.dlitelnostVstupleniyaSek}</div><div style={{ fontSize: "9px" }}></div></div>}
                                    {!item?.dlitelnostVstupleniyaSek && <span> - <span style={{ fontSize: "9px" }}></span></span>}
                                </div>
                            </Tooltip>
                            <Tooltip title={`Хитовость трека${(item?.khitovostTreka) ? " - " + item?.khitovostTreka : ""}`}>
                                <div className="border-grey" style={{ width: "45px", alignSelf: "center", backgroundColor: (item?.khitovostTreka) ? getIndexColorLighter(3, 0.15) : "#f2f2f2", borderRadius: "12px", padding: "0 8px", fontSize: "10px", textAlign: "center" }}>
                                    {item?.khitovostTreka && <div style={{ display: "flex", gap: "3px", alignItems: "center", justifyContent: "center" }}><div><i className="fa fa-star-o"></i> {item?.khitovostTreka}</div><div style={{ fontSize: "9px" }}></div></div>}
                                    {!item?.khitovostTreka && <span> - <span style={{ fontSize: "9px" }}></span></span>}
                                </div>
                            </Tooltip>
                            <Tooltip title={`Сложность трека${(item?.slozhnostTreka) ? " - " + item?.slozhnostTreka : ""}`}>
                                <div className="border-grey" style={{ width: "45px", alignSelf: "center", backgroundColor: (item?.slozhnostTreka) ? getIndexColorLighter(4, 0.15) : "#f2f2f2", borderRadius: "12px", padding: "0 8px", fontSize: "10px", textAlign: "center" }}>
                                    {item?.slozhnostTreka && <div style={{ display: "flex", gap: "3px", alignItems: "center", justifyContent: "center" }}><div><i className="fa fa-lightbulb-o"></i> {item?.slozhnostTreka}</div><div style={{ fontSize: "9px" }}></div></div>}
                                    {!item?.slozhnostTreka && <span> - <span style={{ fontSize: "9px" }}></span></span>}
                                </div>
                            </Tooltip>
                            <Tooltip title={`Количество акцентов за полторы минуты${(item?.kolichestvoAktsentovZaPoltoriMinuti) ? " - " + item?.kolichestvoAktsentovZaPoltoriMinuti : ""}`}>
                                <div className="border-grey" style={{ width: "45px", alignSelf: "center", backgroundColor: (item?.kolichestvoAktsentovZaPoltoriMinuti) ? getIndexColorLighter(5, 0.15) : "#f2f2f2", borderRadius: "12px", padding: "0 8px", fontSize: "10px", textAlign: "center" }}>
                                    {item?.kolichestvoAktsentovZaPoltoriMinuti && <div style={{ display: "flex", gap: "3px", alignItems: "center", justifyContent: "center" }}><div><i className="fa fa-hourglass-start" style={{ fontSize: "8px" }}></i> {item?.kolichestvoAktsentovZaPoltoriMinuti}</div><div style={{ fontSize: "9px" }}></div></div>}
                                    {!item?.kolichestvoAktsentovZaPoltoriMinuti && <span> - <span style={{ fontSize: "9px" }}></span></span>}
                                </div>
                            </Tooltip>
                            <Tooltip title={`Количество акцентов за две минуты${(item?.kolichestvoAktsentovZaDveMinuti) ? " - " + item?.kolichestvoAktsentovZaDveMinuti : ""}`}>
                                <div className="border-grey" style={{ width: "45px", alignSelf: "center", backgroundColor: (item?.kolichestvoAktsentovZaDveMinuti) ? getIndexColorLighter(6, 0.15) : "#f2f2f2", borderRadius: "12px", padding: "0 8px", fontSize: "10px", textAlign: "center" }}>
                                    {item?.kolichestvoAktsentovZaDveMinuti && <div style={{ display: "flex", gap: "3px", alignItems: "center", justifyContent: "center" }}><div><i className="fa fa-hourglass-half" style={{ fontSize: "8px" }}></i> {item?.kolichestvoAktsentovZaDveMinuti}</div><div style={{ fontSize: "9px" }}></div></div>}
                                    {!item?.kolichestvoAktsentovZaDveMinuti && <span> - <span style={{ fontSize: "9px" }}></span></span>}
                                </div>
                            </Tooltip>
                            <Tooltip title={`Кол-во смен ритмов бачаты${(item?.kolvoSmenRitmovBachati) ? " - " + item?.kolvoSmenRitmovBachati : ""}`}>
                                <div className="border-grey" style={{ width: "45px", alignSelf: "center", backgroundColor: (item?.kolvoSmenRitmovBachati) ? getIndexColorLighter(7, 0.15) : "#f2f2f2", borderRadius: "12px", padding: "0 8px", fontSize: "10px", textAlign: "center" }}>
                                    {item?.kolvoSmenRitmovBachati && <div style={{ display: "flex", gap: "3px", alignItems: "center", justifyContent: "center" }}><div><i className="fa fa-level-up"></i> {item?.kolvoSmenRitmovBachati}</div><div style={{ fontSize: "9px" }}></div></div>}
                                    {!item?.kolvoSmenRitmovBachati && <span> - <span style={{ fontSize: "9px" }}></span></span>}
                                </div>
                            </Tooltip>
                            <Tooltip title={`Кол-во обыгрышей${(item?.kolvoObigrishei) ? " - " + item?.kolvoObigrishei : ""}`}>
                                <div className="border-grey" style={{ width: "45px", alignSelf: "center", backgroundColor: (item?.kolvoObigrishei) ? getIndexColorLighter(8, 0.15) : "#f2f2f2", borderRadius: "12px", padding: "0 8px", fontSize: "10px", textAlign: "center" }}>
                                    {item?.kolvoObigrishei && <div style={{ display: "flex", gap: "3px", alignItems: "center", justifyContent: "center" }}><div><i className="fa fa-retweet"></i> {item?.kolvoObigrishei}</div><div style={{ fontSize: "9px" }}></div></div>}
                                    {!item?.kolvoObigrishei && <span> - <span style={{ fontSize: "9px" }}></span></span>}
                                </div>
                            </Tooltip>
                            <Tooltip title={`Энергетика${(item?.energetika) ? " - " + item?.energetika?.nazvanie : ""}`}>
                                <div className="border-grey" style={{ width: "90px", alignSelf: "center", backgroundColor: (item?.energetika) ? getIndexColorLighter(2, 0.15) : "#f2f2f2", borderRadius: "12px", padding: "0 8px", fontSize: "10px", overflow: "hidden", textWrap: "nowrap", textOverflow: "ellipsis", textAlign: "center" }}>
                                    {item?.energetika && <div style={{ display: "flex", gap: "3px", alignItems: "center", justifyContent: "center" }}><div><i className="fa fa-bolt"></i> {item?.energetika?.nazvanie.slice(0, 11)}</div><div style={{ fontSize: "9px" }}></div></div>}
                                    {!item?.energetika && <span> - <span style={{ fontSize: "9px" }}></span></span>}
                                </div>
                            </Tooltip>
                        </div>
                        {/* <div>
                    <AudioPlayer
                        ref={playerRef}
                        className="custom-audio-player"
                        src={ycStorage(auth) + ycBucket(auth) + "/" + item?.src}
                        onPlay={onPlay}
                        onPause={onPause}
                        onEnd={onEnd}
                        onError={onError}
                    />
                </div> */}
                    </div>
                    {(modelActions(item, idx)?.length) && <div style={{ flex: "0 0 25px" }}>
                        <DropdownAction
                            style={{ padding: "0" }}
                            button={() => (<div className={`pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                <i className="fa fa-ellipsis-h"></i>
                            </div>)}
                            items={modelActions(item, idx)?.map((e, idx) => ({
                                key: e.key || idx,
                                auth: auth,
                                mode: "MenuItem",
                                object: item,
                                collection: collection,
                                setCollection: setCollection,
                                ...e
                            }))} />
                    </div>}
                </div>
            </td>

            <RaspredelenieCell {...props} slozhnostProp={1} turIDProp={1} colorProp={9} lightProp={0.10} />
            <RaspredelenieCell {...props} slozhnostProp={1} turIDProp={2} colorProp={9} lightProp={0.14} />
            <RaspredelenieCell {...props} slozhnostProp={1} turIDProp={3} colorProp={9} lightProp={0.18} />

            <RaspredelenieCell {...props} slozhnostProp={2} turIDProp={1} colorProp={10} lightProp={0.10} />
            <RaspredelenieCell {...props} slozhnostProp={2} turIDProp={2} colorProp={10} lightProp={0.14} />
            <RaspredelenieCell {...props} slozhnostProp={2} turIDProp={3} colorProp={10} lightProp={0.18} />

            <RaspredelenieCell {...props} slozhnostProp={3} turIDProp={1} colorProp={11} lightProp={0.10} />
            <RaspredelenieCell {...props} slozhnostProp={3} turIDProp={2} colorProp={11} lightProp={0.14} />
            <RaspredelenieCell {...props} slozhnostProp={3} turIDProp={3} colorProp={11} lightProp={0.18} />

            <RaspredelenieCell {...props} slozhnostProp={4} turIDProp={1} colorProp={17} lightProp={0.10} />
            <RaspredelenieCell {...props} slozhnostProp={4} turIDProp={2} colorProp={17} lightProp={0.14} />
            <RaspredelenieCell {...props} slozhnostProp={4} turIDProp={3} colorProp={17} lightProp={0.18} />

            <RaspredelenieCell {...props} slozhnostProp={5} turIDProp={1} colorProp={13} lightProp={0.10} />
            <RaspredelenieCell {...props} slozhnostProp={5} turIDProp={2} colorProp={13} lightProp={0.14} />
            <RaspredelenieCell {...props} slozhnostProp={5} turIDProp={3} colorProp={13} lightProp={0.18} />
        </tr>
    )
}
function TrekVPleiListakh(props) {
    const { auth, item, idx, modelActions, collection, setCollection, style, className } = props;

    const {
        tracks,
        setTracks,
        currentTrack,
        setCurrentTrack,
        audioRef,
        progressBarRef,
        timeProgress,
        setTimeProgress,
        duration,
        setDuration,
        setTrackIndex,
        isPlaying,
        setIsPlaying,
    } = useAudioPlayerContext();

    const play = () => {
        if (currentTrack?.ID === item?.ID && isPlaying) {
            setIsPlaying(false);
        } else {
            setCurrentTrack(item);
            setIsPlaying(true);
        }
    };

    return (
        <div key={idx} className={className} style={{ ...style, display: "flex", alignItems: "center", gap: "10px", marginBottom: "2px", textAlign: "left" }}>
            <div onClick={play}>
                <YAudioImage
                    playing={currentTrack?.ID === item?.ID && isPlaying}
                    error={false}
                    width={55}
                    image={item.picture}
                    minimage={item.picture}
                    hidePreview={true}
                    imageStyle={{ borderRadius: "4px", border: "1px solid #ebebeb", borderRadius: "4px" }}
                />
            </div>
            <div style={{ flex: "1 1 auto" }}>
                <div style={{ fontWeight: "bold" }}>
                    {item.nazvanieTreka}
                </div>
                <div style={{ fontWeight: "normal", fontSize: "12px", color: "rgba(0,0,0,0.65)", display: "flex", gap: "10px" }}>
                    {item?.sozdateliTrekaTrek?.length && <div>
                        {JSXMap(item.sozdateliTrekaTrek, (sitem, idx) => {
                            return (<span key={idx}>{(idx > 0) ? ", " : ""}{sitem?.sozdatel?.familiya} {sitem?.sozdatel?.imya}{(sitem?.sozdatel?.psevdonim) ? " (" + sitem?.sozdatel?.psevdonim + ")" : ""}</span>)
                        })}
                    </div>}
                </div>
                <div style={{ display: "flex", gap: "3px" }}>
                    <Tooltip title={`Темп${(item?.temp) ? " - " + item?.temp : ""}`}>
                        <div className="border-grey" style={{ width: "55px", alignSelf: "center", backgroundColor: (item?.temp) ? getIndexColorLighter(0, 0.15) : "#f2f2f2", borderRadius: "12px", padding: "0 8px", fontSize: "10px", textAlign: "center" }}>
                            {item?.temp && <div style={{ display: "flex", gap: "2px", alignItems: "center", justifyContent: "center" }}><div></div>{item?.temp} <div style={{ fontSize: "9px" }}>bpm</div></div>}
                            {!item?.temp && <span> - <span style={{ fontSize: "9px" }}></span></span>}
                        </div>
                    </Tooltip>
                    <Tooltip title={`Длительность вступления${(item?.dlitelnostVstupleniyaSek) ? " - " + item?.dlitelnostVstupleniyaSek : ""}`}>
                        <div className="border-grey" style={{ width: "45px", alignSelf: "center", backgroundColor: (item?.dlitelnostVstupleniyaSek) ? getIndexColorLighter(1, 0.15) : "#f2f2f2", borderRadius: "12px", padding: "0 8px", fontSize: "10px", textAlign: "center" }}>
                            {item?.dlitelnostVstupleniyaSek && <div style={{ display: "flex", gap: "3px", alignItems: "center", justifyContent: "center" }}><div><i className="fa fa-long-arrow-right"></i></div>{item?.dlitelnostVstupleniyaSek} <div style={{ fontSize: "9px" }}></div></div>}
                            {!item?.dlitelnostVstupleniyaSek && <span> - <span style={{ fontSize: "9px" }}></span></span>}
                        </div>
                    </Tooltip>
                    <Tooltip title={`Хитовость трека${(item?.khitovostTreka) ? " - " + item?.khitovostTreka : ""}`}>
                        <div className="border-grey" style={{ width: "45px", alignSelf: "center", backgroundColor: (item?.khitovostTreka) ? getIndexColorLighter(3, 0.15) : "#f2f2f2", borderRadius: "12px", padding: "0 8px", fontSize: "10px", textAlign: "center" }}>
                            {item?.khitovostTreka && <div style={{ display: "flex", gap: "3px", alignItems: "center", justifyContent: "center" }}><div><i className="fa fa-star-o"></i></div>{item?.khitovostTreka} <div style={{ fontSize: "9px" }}></div></div>}
                            {!item?.khitovostTreka && <span> - <span style={{ fontSize: "9px" }}></span></span>}
                        </div>
                    </Tooltip>
                    <Tooltip title={`Сложность трека${(item?.slozhnostTreka) ? " - " + item?.slozhnostTreka : ""}`}>
                        <div className="border-grey" style={{ width: "45px", alignSelf: "center", backgroundColor: (item?.slozhnostTreka) ? getIndexColorLighter(4, 0.15) : "#f2f2f2", borderRadius: "12px", padding: "0 8px", fontSize: "10px", textAlign: "center" }}>
                            {item?.slozhnostTreka && <div style={{ display: "flex", gap: "3px", alignItems: "center", justifyContent: "center" }}><div><i className="fa fa-lightbulb-o"></i></div>{item?.slozhnostTreka} <div style={{ fontSize: "9px" }}></div></div>}
                            {!item?.slozhnostTreka && <span> - <span style={{ fontSize: "9px" }}></span></span>}
                        </div>
                    </Tooltip>
                    <Tooltip title={`Количество акцентов за полторы минуты${(item?.kolichestvoAktsentovZaPoltoriMinuti) ? " - " + item?.kolichestvoAktsentovZaPoltoriMinuti : ""}`}>
                        <div className="border-grey" style={{ width: "45px", alignSelf: "center", backgroundColor: (item?.kolichestvoAktsentovZaPoltoriMinuti) ? getIndexColorLighter(5, 0.15) : "#f2f2f2", borderRadius: "12px", padding: "0 8px", fontSize: "10px", textAlign: "center" }}>
                            {item?.kolichestvoAktsentovZaPoltoriMinuti && <div style={{ display: "flex", gap: "3px", alignItems: "center", justifyContent: "center" }}><div><i className="fa fa-hourglass-start" style={{ fontSize: "8px" }}></i></div>{item?.kolichestvoAktsentovZaPoltoriMinuti} <div style={{ fontSize: "9px" }}></div></div>}
                            {!item?.kolichestvoAktsentovZaPoltoriMinuti && <span> - <span style={{ fontSize: "9px" }}></span></span>}
                        </div>
                    </Tooltip>
                    <Tooltip title={`Количество акцентов за две минуты${(item?.kolichestvoAktsentovZaDveMinuti) ? " - " + item?.kolichestvoAktsentovZaDveMinuti : ""}`}>
                        <div className="border-grey" style={{ width: "45px", alignSelf: "center", backgroundColor: (item?.kolichestvoAktsentovZaDveMinuti) ? getIndexColorLighter(6, 0.15) : "#f2f2f2", borderRadius: "12px", padding: "0 8px", fontSize: "10px", textAlign: "center" }}>
                            {item?.kolichestvoAktsentovZaDveMinuti && <div style={{ display: "flex", gap: "3px", alignItems: "center", justifyContent: "center" }}><div><i className="fa fa-hourglass-half" style={{ fontSize: "8px" }}></i></div>{item?.kolichestvoAktsentovZaDveMinuti} <div style={{ fontSize: "9px" }}></div></div>}
                            {!item?.kolichestvoAktsentovZaDveMinuti && <span> - <span style={{ fontSize: "9px" }}></span></span>}
                        </div>
                    </Tooltip>
                    <Tooltip title={`Кол-во смен ритмов бачаты${(item?.kolvoSmenRitmovBachati) ? " - " + item?.kolvoSmenRitmovBachati : ""}`}>
                        <div className="border-grey" style={{ width: "45px", alignSelf: "center", backgroundColor: (item?.kolvoSmenRitmovBachati) ? getIndexColorLighter(7, 0.15) : "#f2f2f2", borderRadius: "12px", padding: "0 8px", fontSize: "10px", textAlign: "center" }}>
                            {item?.kolvoSmenRitmovBachati && <div style={{ display: "flex", gap: "3px", alignItems: "center", justifyContent: "center" }}><div><i className="fa fa-level-up"></i></div>{item?.kolvoSmenRitmovBachati} <div style={{ fontSize: "9px" }}></div></div>}
                            {!item?.kolvoSmenRitmovBachati && <span> - <span style={{ fontSize: "9px" }}></span></span>}
                        </div>
                    </Tooltip>
                    <Tooltip title={`Кол-во обыгрышей${(item?.kolvoObigrishei) ? " - " + item?.kolvoObigrishei : ""}`}>
                        <div className="border-grey" style={{ width: "45px", alignSelf: "center", backgroundColor: (item?.kolvoObigrishei) ? getIndexColorLighter(8, 0.15) : "#f2f2f2", borderRadius: "12px", padding: "0 8px", fontSize: "10px", textAlign: "center" }}>
                            {item?.kolvoObigrishei && <div style={{ display: "flex", gap: "3px", alignItems: "center", justifyContent: "center" }}><div><i className="fa fa-retweet"></i></div>{item?.kolvoObigrishei} <div style={{ fontSize: "9px" }}></div></div>}
                            {!item?.kolvoObigrishei && <span> - <span style={{ fontSize: "9px" }}></span></span>}
                        </div>
                    </Tooltip>
                    <Tooltip title={`Энергетика${(item?.energetika) ? " - " + item?.energetika?.nazvanie : ""}`}>
                        <div className="border-grey" style={{ width: "90px", alignSelf: "center", backgroundColor: (item?.energetika) ? getIndexColorLighter(2, 0.15) : "#f2f2f2", borderRadius: "12px", padding: "0 8px", fontSize: "10px", overflow: "hidden", textWrap: "nowrap", textOverflow: "ellipsis", textAlign: "center" }}>
                            {item?.energetika && <div style={{ display: "flex", gap: "3px", alignItems: "center", justifyContent: "center" }}><div><i className="fa fa-bolt"></i></div>{item?.energetika?.nazvanie.slice(0, 11)} <div style={{ fontSize: "9px" }}></div></div>}
                            {!item?.energetika && <span> - <span style={{ fontSize: "9px" }}></span></span>}
                        </div>
                    </Tooltip>

                </div>
            </div>
            {/* {(modelActions(item, idx)?.length) && <div style={{ flex: "0 0 25px" }}>
                <DropdownAction
                    style={{ padding: "0" }}
                    button={() => (<div className={`pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                        <i className="fa fa-ellipsis-h"></i>
                    </div>)}
                    items={modelActions(item, idx)?.map((e, idx) => ({
                        key: e.key || idx,
                        auth: auth,
                        mode: "MenuItem",
                        object: item,
                        collection: collection,
                        setCollection: setCollection,
                        ...e
                    }))} />
            </div>} */}
        </div>
    )
}
// function BasePlaylist(props) {
//     const {
//         tracks,
//         setTracks,
//         currentTrack,
//         setCurrentTrack,
//         audioRef,
//         progressBarRef,
//         timeProgress,
//         setTimeProgress,
//         duration,
//         setDuration,
//         setTrackIndex,
//         isPlaying,
//         setIsPlaying,
//     } = useAudioPlayerContext();
//     return (<div></div>)
// }
function Treki(props) {
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const auth = useAuth();
    const t = useTranslateContext();
    const user = useUserContext();
    const meta = useMetaContext();
    const [userConfig, setUserConfig] = useUserConfigContext();
    const siteAccess = useSelector(state => state.siteAccess.value);

    const filtersFromMeta = React.useCallback((name, funcs) => {
        let prop = [];
        // let p = _.get(meta[name], "properties");
        let p = GetMetaProperties(meta[name])
        p = deleteInProperties(p, ["CreatedAt", "UpdatedAt", "DeletedAt", "Creator", "Src", "Hash", "ID"])
        if (funcs) {
            for (let i = 0; i < funcs.length; i++) {
                const f = funcs[i];
                p = f(p);
            }
        }
        if (p) {
            prop = p?.filter(e => !_.get(e, "relation") || _.get(e, "relation.type") !== "one-many")?.map(e => ({ ...e, sort: true, filter: true, func: (e.filterType == "range") ? ["min", "max"] : undefined }))
        }
        return prop;
    }, [meta]);

    let metaTreki = _.get(meta, "Treki");

    const trekiProperties = (obj, hideFile, extarray) => {
        let r = [];
        if (extarray) {
            r.push(...extarray)
        }
        let pr = obj.properties.filter(n => {
            return n.name !== "CreatedAt" && n.name !== "UpdatedAt" && n.name !== "DeletedAt" && n.name !== "Creator" &&
                n.name !== "Src" && n.name !== "Hash" && n.name !== "Picture"
            // && n.name !== "DataRazmeshcheniya"
            // && n.name !== "ObshchayaDlitelnost"
        })
        if (pr) {
            r.push(...pr)
        }
        r = updateInProperties(r, {
            name: "Kommentarii",
            type: "text"
            // type: "func",
            // render: (auth, item, value, onChange, onAfterChange, isChanged) => {
            //     return (<MDEditor

            //         data-color-mode="light"
            //         value={value} onChange={onChange}
            //         preview={"preview"}
            //         overflow={false}
            //         commands={[]}
            //     />)
            // }
        })
        r = updateInProperties(r, {
            name: "TemaPesni",
            type: "text"
            // type: "func",
            // render: (auth, item, value, onChange, onAfterChange, isChanged) => {
            //     return (<MDEditor

            //         data-color-mode="light"
            //         value={value} onChange={onChange}
            //         preview={"preview"}
            //         overflow={false}
            //         commands={[]}
            //     />)
            // }
        })

        if (!hideFile) {
            r.push({
                label: "Файл",
                name: "file",
                type: "file",
            })
        }

        return r
    }
    const cleanProperties = (obj, context, funcs) => {
        const { name, field, fieldName, contextObject, object } = context;
        if (!obj) { return obj }
        let p = GetMetaProperties(obj)
        p = deleteInProperties(p, ["CreatedAt", "UpdatedAt", "DeletedAt"])
        if (object && obj.type == "object") {
            p = updateInPropertiesUUID(p, {
                uuid: "object-owner-description",
                type: "func",
                render: () => (<ObjectOwnerDescription object={object} style={{ marginBottom: "5px" }} />)
            }, true)
        }
        if (contextObject && obj.type == "object" && field) {
            let fName = _.get(field, "relation.reference.property");
            let o = obj?.properties?.find(e => e.name == fName)
            if (o) {
                let oObj = _.get(o, "relation.reference.object");
                let oMeta = meta[oObj];
                p = updateInPropertiesUUID(p, {
                    uuid: "object-context-description",
                    type: "func",
                    render: () => (<div className='bg bg-grey' style={{ textAlign: "left", padding: "5px", marginBottom: "5px" }}>
                        {(oMeta) && <div style={{
                            fontSize: "10px",
                            color: "rgb(106, 106, 106)",
                            lineHeight: "10px",
                            fontStyle: "italic"
                        }}>{o?.label} ({oMeta?.label})</div>}
                        <div>{getObjectDisplay(contextObject, oObj, meta)}</div>
                        <div style={{ color: "#6a6a6a" }}><ObjectOwnerDescription object={contextObject} inline={true} /></div>
                    </div>)
                }, true)
            }
        }
        if (funcs) {
            for (let i = 0; i < funcs.length; i++) {
                const f = funcs[i];
                p = f(p);
            }
        }

        p = foreachInProperties(p, n => (n.name == "Kommentarii"), {
            type: "text"
        })
        p = foreachInProperties(p, n => (n.type == "object" && n.name == "TipDlyaTreka"), {
            relation: {
                displayString: (item) => {
                    return item?.nazvanie
                },
                display: (item) => {
                    return (
                        <div>{item?.nazvanie}</div>
                    )
                },
                reference: { object: "TipiDlyaTrekov", property: "ID" },
                type: "many-one",
            },
            queryFilter: [
                QueryDetail("collection"),
                QueryOrder("nazvanie", "ASC"),
            ],
        })
        p = foreachInProperties(p, n => (n.type == "object" && n.name == "RaspredeleniePoKategoriyamTrek"), (n) => {
            return ({
                queryFilter: [
                    QueryDetail("collection"),
                    // QueryOrder("sozdatel.familiya", "ASC"),
                ],
                relation: {
                    ...n?.relation,
                    uiFilter: () => [],
                    displayString: (item) => {
                        return `${item?.distsiplina?.nazvanie} - ${item?.kategoriya?.nazvanie} Тур: ${item?.tur?.nazvanie}, Порядковый номер в туре: ${item?.poryadkoviiNomerVTure}, Сложность: ${item?.slozhnost}`
                    },
                    display: (item) => {
                        return (
                            <div>
                                <div style={{ fontSize: "12px", color: "rgba(0,0,0,0.65)" }}>
                                    {item?.distsiplina?.nazvanie} - {item?.kategoriya?.nazvanie}
                                </div>
                                <div>Тур: {item?.tur?.name}, Порядковый номер в туре: {item?.poryadkoviiNomerVTure}</div>
                                <div style={{ color: "rgba(0,0,0,0.65)" }}>Сложность: {item?.slozhnost}</div>
                            </div>
                        )
                    },
                },
            })
        })
        p = foreachInProperties(p, n => (n.type == "object" && n.name == "SozdateliTrekaTrek"), (n) => {
            return ({
                queryFilter: [
                    QueryDetail("collection"),
                    QueryOrder("sozdatel.familiya", "ASC"),
                ],
                relation: {
                    ...n?.relation,
                    uiFilter: () => [],
                    displayString: (item) => {
                        return `${item?.tipDlyaTreka?.nazvanie}: ${item?.sozdatel?.familiya} ${item?.sozdatel?.imya}${(item?.sozdatel?.psevdonim) ? " (" + item?.sozdatel?.psevdonim + ")" : ""}`
                    },
                    display: (item) => {
                        return (
                            <div>
                                <div style={{ fontSize: "12px", color: "rgba(0,0,0,0.65)" }}>{item?.tipDlyaTreka?.nazvanie}</div>
                                <div>{item?.sozdatel?.familiya} {item?.sozdatel?.imya}</div>
                                {/* <div style={{ color: "rgba(0,0,0,0.65)" }}>{item?.sozdatel?.psevdonim}</div> */}
                            </div>
                        )
                    },
                },
            })
        })
        p = foreachInProperties(p, n => (n.type == "object" && n.name == "Sozdatel"), (n) => ({
            queryFilter: [
                QueryDetail("collection"),
                QueryOrder("familiya", "ASC"),
            ],
            relation: {
                ...n?.relation,
                displayString: (item) => {
                    return `${item?.familiya} ${item?.imya}${(item?.psevdonim) ? " (" + item?.psevdonim + ")" : ""}`
                },
                display: (item) => {
                    return (
                        <div>
                            <div>{item?.familiya} {item?.imya}</div>
                            {/* <div style={{ fontSize: "12px", color: "rgba(0,0,0,0.65)" }}>{item?.psevdonim}</div> */}
                        </div>
                    )
                },
            },
            dropdownActions: () => [
                {
                    title: "Добавить создателя трека",
                    form: Model,
                    meta: [
                        {
                            label: "Фамилия",
                            name: "familiya",
                            type: "string",
                        },
                        {
                            label: "Имя",
                            name: "imya",
                            type: "string",
                        },
                        {
                            label: "Псевдоним",
                            name: "psevdonim",
                            type: "string",
                        },
                        {
                            label: "Страна",
                            name: "strana",
                            type: "object",
                            relation: {
                                displayString: (item) => {
                                    return item?.name
                                },
                                display: (item) => {
                                    return (
                                        <div>
                                            <div>{item?.name}</div>
                                            {/* <div style={{fontSize:"12px", color:"rgba(0,0,0,0.65)"}}>{item?.code}</div> */}
                                        </div>
                                    )
                                },
                                reference: { object: "Countries", property: "ID" },
                                type: "many-one",
                            },
                            queryFilter: [
                                // QueryDetail("model"),
                                QueryOrder("name", "ASC")
                            ],
                        },
                    ],
                    action: (values, unlock, close, { collection, setCollection, apply }) => {
                        CREATE(auth, 'BazaSozdateleiTrekov', { ...values },
                            ({ data }) => {
                                setCollection(updateInArray(collection, data));
                                if (apply) {
                                    apply(data);
                                }
                                close();
                            },
                            (err) => errorCatch(err, unlock)
                        );
                    },
                },
            ]
        }))

        // p = foreachInProperties(p, n => (obj.name === "NastroikiOtsenokProtokolovTesta" && n.name === "ParametrKriteriya"), {
        //     source: `/api/testisudeiskikhattestatsii/criterion-params-by-tantsor/${contextObject?.ID}`,
        //     dropdownActions: undefined
        // })

        return SetMetaProperties(obj, p)
    }

    const [essentia, setEssentia] = useState();
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    const audioContext = new AudioContext();

    useEffect(() => {
        import(
            /* webpackChunkName: "my-chunk-name" */
            /* webpackExports: ["default", "named"] */
            'essentia.js')
            .then(async (esPkg) => {
                const ess = new esPkg.Essentia(esPkg.EssentiaWASM.EssentiaWASM);
                setEssentia(ess)
            }).catch(err => {
                console.error("Ошибка загрузки essentia.js", err)
            });
    }, [])

    function downsampleAudioBuffer(buf, rate) {
        var channels = buf.numberOfChannels;
        var sampleRate = buf.sampleRate

        if (rate == sampleRate) {
            return buf;
        }
        if (rate > sampleRate) {
            throw "downsampling rate show be smaller than original sample rate";
        }

        var sampleRateRatio = sampleRate / rate;
        var newLength = Math.round(buf?.getChannelData(0)?.length / sampleRateRatio);
        var toBuffer = audioContext.createBuffer(channels, newLength, rate);

        for (var i = 0; i < channels; i++) {
            var buffer = buf.getChannelData(i);
            var toChanData = toBuffer.getChannelData(i);

            var offsetResult = 0;
            var offsetBuffer = 0;

            while (offsetResult < toChanData.length) {
                var nextOffsetBuffer = Math.round((offsetResult + 1) * sampleRateRatio);
                // Use average value of skipped samples
                var accum = 0, count = 0;
                for (var i = offsetBuffer; i < nextOffsetBuffer && i < buffer.length; i++) {
                    accum += buffer[i];
                    count++;
                }
                toChanData[offsetResult] = accum / count;
                // Or you can simply get rid of the skipped samples:
                // result[offsetResult] = buffer[nextOffsetBuffer];
                offsetResult++;
                offsetBuffer = nextOffsetBuffer;
            }
        }
        return toBuffer;
    }

    function copyBuffer(fromBuffer, fromStart, fromEnd, toStart) {

        var sampleRate = fromBuffer.sampleRate;

        var frameCount = fromBuffer.length;
        if (fromEnd && fromEnd > 0) {

            var frameCount = (fromEnd - fromStart) * sampleRate;
            if (frameCount > fromBuffer.length) {
                frameCount = fromBuffer.length
            }
        }


        var channels = fromBuffer.numberOfChannels;
        var toBuffer = audioContext.createBuffer(channels, frameCount, sampleRate);

        for (var i = 0; i < fromBuffer.numberOfChannels; i++) {
            var fromChanData = fromBuffer.getChannelData(i);
            var toChanData = toBuffer.getChannelData(i);
            for (var j = 0, f = Math.round(fromStart * sampleRate), t = Math.round(toStart * sampleRate); j < frameCount; j++, f++, t++) {
                toChanData[t] = fromChanData[f];
            }
        }
        return toBuffer
    }

    function downsampleBuffer(buf, rate) {
        var buffer = buf.getChannelData(0);
        var sampleRate = buf.sampleRate

        if (rate == sampleRate) {
            return buffer;
        }
        if (rate > sampleRate) {
            throw "downsampling rate show be smaller than original sample rate";
        }
        var sampleRateRatio = sampleRate / rate;
        var newLength = Math.round(buffer.length / sampleRateRatio);
        var result = new Float32Array(newLength);
        var offsetResult = 0;
        var offsetBuffer = 0;
        while (offsetResult < result.length) {
            var nextOffsetBuffer = Math.round((offsetResult + 1) * sampleRateRatio);
            // Use average value of skipped samples
            var accum = 0, count = 0;
            for (var i = offsetBuffer; i < nextOffsetBuffer && i < buffer.length; i++) {
                accum += buffer[i];
                count++;
            }
            result[offsetResult] = accum / count;
            // Or you can simply get rid of the skipped samples:
            // result[offsetResult] = buffer[nextOffsetBuffer];
            offsetResult++;
            offsetBuffer = nextOffsetBuffer;
        }
        return result;
    }

    const getTags = async (fileName, arrayBuffer) => {
        let id3 = await ID3v2FromBlob(arrayBuffer)
        let tags = {};
        var keys = Object.keys(id3);
        var texts = [
            "Файл: " + fileName
        ]
        for (const key of keys) {
            if (
                key !== "APIC" &&
                key !== "TOPE" &&
                key !== "TPE1" &&
                key !== "TPE2" &&
                key !== "TIT2" &&
                key !== "TALB" &&
                key !== "TRCK" &&
                key !== "TYER" &&
                // key !== "TCON" &&
                key !== "TBPM"
            ) {
                texts.push(`${validFramesIds[key]}: ${id3[key]?.value}`);
            }
        }
        let tname = ""
        if (fileName) {
            tname = fileName.replace(/\.[^/.]+$/, "")
        }
        if ((id3?.TOPE?.value || id3?.TPE1?.value || id3?.TPE2?.value) && id3?.TIT2?.value) {
            tname = //(id3?.TOPE?.value || id3?.TPE1?.value || id3?.TPE2?.value) + " - " + 
                id3?.TIT2?.value;
        }
        if (keys.length > 0) {
            tags = {
                // ...data?.file,
                filename: fileName,
                picture: id3?.APIC?.value,
                author: id3?.TOPE?.value || id3?.TPE1?.value || id3?.TPE2?.value,
                title: id3?.TIT2?.value,
                album: id3?.TALB?.value,
                treck: id3?.TRCK?.value,
                year: id3?.TYER?.value,
                bpm: id3?.TBPM?.value,

                // genre: id3?.TCON?.value,
                kommentarii: texts.join("\n\n"),
                nazvanieTreka: tname,
                godSozdaniya: id3?.TYER?.value
            }
        }
        return tags;
    }
    const {
        tracks,
        setTracks,
        currentTrack,
        setCurrentTrack,
        audioRef,
        progressBarRef,
        timeProgress,
        setTimeProgress,
        duration,
        setDuration,
        setTrackIndex,
        isPlaying,
        setIsPlaying,
    } = useAudioPlayerContext();

    return (<CollectionServer
        auth={auth}
        name={"Treki"}
        source={`/api/treki/list`}
        filters={() => filtersFromMeta(metaTreki.name)}
        onCollectionChange={(collection) => {
            let track = _.first(collection);
            setTracks(collection)
            setCurrentTrack(track);
            // setIsPlaying(true);
        }}
        customRender={(items, {
            collection,
            setCollection,
            setCollectionItem,
            removeCollectionItem,
            collectionActions,
            modelActions,
            loading,
            update
        }) => (
            <div>
                <Spin spinning={loading}>
                    {JSXMap(items, (item, idx) => {
                        return (
                            <Trek className={`bg ${(idx % 2 > 0) ? "bg-grey light-15" : "bg-fwhite"} pointer`} auth={auth} key={idx} item={item} modelActions={modelActions} collection={collection} setCollection={setCollection} />
                        )
                    })}
                </Spin>
            </div>
        )}
        size={"small"}

        mode="list"
        linksModelActions={"inline"}
        scheme={[
            "SozdateliTrekaTrek",
            "SozdateliTreka.TipDlyaTreka",
            "SozdateliTreka.Sozdatel",
            "RaspredeleniePoKategoriyamTrek",
        ]}

        collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
            if (name === "Treki") {
                return [{
                    auth: auth,
                    action: (values, unlock, close, { collection, setCollection }) => {
                        let v = { ...values?.params, file: values?.file?.file, dataRazmeshcheniya: dayjs().format("YYYY-MM-DD") }
                        POSTFormData(auth, `/api/treki/new`, makeFormData(v),
                            ({ data }) => {
                                setCollection(updateInArray(collection, data, true));
                                close();
                            },
                            (err) => errorCatch(err, unlock));
                    },
                    modal: {
                        // title: "!!!",
                        maskClosable: false,
                    },
                    title: "Добавить трек",
                    steps: [
                        {
                            key: "file",
                            name: "Выбор файла",
                            action: (values, unlock, close) => {
                                // let v = values;
                                close(values)
                            },
                            form: Model,
                            meta: () => [{
                                label: "Файл",
                                name: "file",
                                type: "file",
                            }],
                            okText: "Загрузить"
                        },
                        {
                            key: "params",
                            name: "Параметры",
                            okText: "Отправить",
                            form: (props) => {
                                const { object, data } = props;
                                return (<div>
                                    <AudioProperties {...props} response={(async () => {
                                        if (data?.file?.file?.length) {
                                            let file = data?.file?.file;
                                            let arrayBuffer = await file?.[0]?.arrayBuffer();
                                            return {
                                                arrayBuffer: arrayBuffer,
                                                url: URL.createObjectURL(file?.[0]),
                                                tags: await getTags(file?.[0]?.name, arrayBuffer),
                                            }
                                        }
                                    })()} />
                                </div>)
                            },
                            meta: () => trekiProperties(metaTreki, true),
                        }
                    ]
                }]
            }
            return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject }) }))
        }}
        modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
            if (name === "Treki") {
                return [
                    {
                        auth: auth,
                        title: "Изменить",
                        modal: {
                            title: "Изменить трек",
                        },
                        object: item,
                        links: "inline",
                        scheme: [
                            "SozdateliTrekaTrek",
                            "SozdateliTreka.TipDlyaTreka",
                            "SozdateliTreka.Sozdatel",
                            "RaspredeleniePoKategoriyamTrek",
                        ],
                        collectionActions: ({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                            return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject }) }))
                        },
                        modelActions: (item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                            return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }))
                        },
                        isFormData: true,
                        modify: (values) => {
                            return { /*...item,*/ ...values, ID: item.ID }
                        },
                        action: (values, unlock, close, { collection, setCollection }) => {
                            POSTFormData(auth, `/api/treki/update`, values,
                                ({ data }) => {
                                    setCollection(updateInArray(collection, data));
                                    close();
                                },
                                (err) => errorCatch(err, unlock));
                        },
                        modal: {
                            // title: "!!!",
                            maskClosable: false,
                        },
                        form: (props) => {
                            const { object } = props;
                            return (<div>
                                <AudioProperties {...props} response={(async () => {

                                    const file = await fetch(ycStorage(auth) + ycBucket(auth) + "/" + object.src);
                                    let arrayBuffer = await file?.arrayBuffer();
                                    return {
                                        arrayBuffer: arrayBuffer,
                                        url: file?.url,
                                        tags: await getTags(object?.nazvanieTreka, arrayBuffer)
                                    }
                                })()} />
                            </div>)
                        },
                        meta: () => cleanProperties(trekiProperties(metaTreki, true), { name, field, fieldName, contextObject, object: item }),
                    },
                    {
                        auth: auth,
                        title: <span style={{ color: "red" }}>Удалить</span>,
                        action: (values, unlock, close, { collection, setCollection }) => {
                            confirmKey({
                                pass: '123',
                                title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить трек</span>,
                                icon: undefined,
                                content: <span>Вы действительно хотите удалить трек?</span>,
                                okText: 'Удалить',
                                cancelText: 'Отмена',
                                onOk() {
                                    return new Promise((resolve, reject) => {
                                        GET(auth, '/api/treki/delete/' + item.ID,
                                            ({ data }) => {
                                                setCollection(deleteInArray(collection, item));
                                                resolve(data);
                                            }, (err) => errorCatch(err, reject));
                                    }).catch(() => { });
                                },
                                onCancel() {
                                },
                            })

                        }
                    }]
            }
            return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }))
        }}
    />)
}
function RaspredeleniePoKategoriyam(props) {
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const auth = useAuth();
    const t = useTranslateContext();
    const user = useUserContext();
    const meta = useMetaContext();
    const [userConfig, setUserConfig] = useUserConfigContext();
    const siteAccess = useSelector(state => state.siteAccess.value);

    const filtersFromMeta = React.useCallback((name, funcs) => {
        let prop = [];
        // let p = _.get(meta[name], "properties");
        let p = GetMetaProperties(meta[name])
        p = deleteInProperties(p, ["CreatedAt", "UpdatedAt", "DeletedAt", "Creator", "Src", "Hash", "ID"])
        if (funcs) {
            for (let i = 0; i < funcs.length; i++) {
                const f = funcs[i];
                p = f(p);
            }
        }
        if (p) {
            prop = p?.filter(e => !_.get(e, "relation") || _.get(e, "relation.type") !== "one-many")?.map(e => ({ ...e, sort: true, filter: true, func: (e.filterType == "range") ? ["min", "max"] : undefined }))
        }
        return prop;
    }, [meta]);

    let metaTreki = _.get(meta, "Treki");
    let metaRaspredeleniePoKategoriyam = _.get(meta, "RaspredeleniePoKategoriyam");

    const [distsiplina, setDistsiplina] = useState(3);

    const {
        tracks,
        setTracks,
        currentTrack,
        setCurrentTrack,
        audioRef,
        progressBarRef,
        timeProgress,
        setTimeProgress,
        duration,
        setDuration,
        setTrackIndex,
        isPlaying,
        setIsPlaying,
    } = useAudioPlayerContext();

    return (<div>
        <div style={{ margin: "0 0 10px 0" }}>
            {JSX(() => { // Танцевальная дисциплина
                let item = {
                    "name": "Distsiplina",
                    "type": "object",
                    "label": "Танцевальная дисциплина",
                    "relation": {
                        "type": "many-one",
                        "reference": {
                            "object": "TantsevalnieDistsiplini",
                            "property": "ID"
                        },
                    },
                    "validators": {
                        "required": true,
                        "min": null,
                        "max": null,
                        "pattern": null
                    },
                }
                return (
                    <Field
                        value={distsiplina}
                        onChange={setDistsiplina}
                        key={item?.name}
                        auth={auth}
                        item={item}
                    />
                )
            })}
        </div>
        <CollectionServer
            auth={auth}
            name={"RaspredeleniePoKategoriyam"}
            source={`/api/treki/list-detail-respred/${distsiplina}`}
            floatingFilter={true}
            filters={() => filtersFromMeta(metaTreki.name, [
                // raspredeleniePoKategoriyamTrek.

                (p) => {
                    return foreachInProperties(p, n => (n.name == "Energetika"), {
                        display: (item) => {
                            return item?.nazvanie
                        },
                    })
                },
                (p) => {
                    return updateInProperties(p, {
                        // {
                        //     label: <FilterFieldLabel label="Владелец счетов" badge="or" color="#919191" background="rgba(216, 216, 216, 0.2)" />,
                        //     name: "vladeletsSchetov",
                        //     // queryComparer:"swsim", // sim, wsim, swsim
                        //     sort: false,
                        //     filter: true,
                        //     type: "func",
                        //     render: (auth, item, value, onChange, onAfterChange, isChanged) => {
                        //         return <Field auth={auth} item={{...item, type: "string"}} value={value} onChange={onChange} onAfterChange={onAfterChange} isChanged={isChanged} />;
                        //     }
                        // },
                        // {
                        //     name: "isCalcRelR",
                        //     sort: true,
                        //     filter: true,
                        //     label: "Отображать мероприятия",
                        //     type: "object",
                        //     relation: {
                        //         display: (item) => {
                        //             return item.name
                        //         },
                        //         reference: {
                        //             data: [
                        //                 { ID: 1, name: "Рассчитанные" },
                        //                 { ID: 2, name: "Нерассчитанные" },
                        //             ]
                        //         },
                        //         type: "many-one",
                        //     },
                        //     queryRaw: (value, item, key) => {
                        //         if (value == 1) {
                        //             return QueryParam("w-isCalcOtnositelniyRating", "true")

                        //         } else if (value == 2) {
                        //             return QueryParam("w-isCalcOtnositelniyRating", "false")
                        //         }
                        //         return ""
                        //     },
                        //     filtered: 1,
                        // },
                        name: "raspredeleniePoKategoriyamTrek.slozhnost",
                        type: "int",
                        min: 1,
                        max: 5,
                        // filterType: "group",
                        // label: <FilterFieldLabel label="Сложность категории" badge="or" color="#919191" background="rgba(216, 216, 216, 0.2)" />,
                        label: "Сложность категории",
                        // sort: false,
                        filter: true,
                    })
                },
                (p) => {
                    return updateInProperties(p, {
                        name: "raspredeleniePoKategoriyamTrek.tur",
                        label: "Тип тура",
                        type: "object",
                        filterType: "group",
                        "relation": {
                            "type": "many-one",
                            displayString: (item) => {
                                return item?.name
                            },
                            display: (item) => {
                                return (
                                    item?.name
                                )
                            },
                            "reference": {
                                "object": "TourType",
                                "property": "ID"
                            },
                        },
                        queryFilter: [
                            QueryOrder("name", "ASC")
                        ],
                        "sort": true,
                        "filter": true
                    })
                },
                (p) => {
                    return updateInProperties(p, {
                        name: "raspredeleniePoKategoriyamTrek.poryadkoviiNomerVTure",
                        // sort: true,
                        filter: true,
                        label: "Порядковый номер в туре",
                        type: "object",
                        filterType: "group",
                        relation: {
                            display: (item) => {
                                return item.name
                            },
                            reference: {
                                data: [
                                    { ID: 1, name: "1" },
                                    { ID: 2, name: "2" },
                                    { ID: 3, name: "3" },
                                    { ID: 4, name: "4" },
                                    { ID: 5, name: "5" },
                                    { ID: 0, name: <i className="fa fa-check"></i> },
                                ]
                            },
                            type: "many-one",
                        },
                        queryRaw: (value, item, key) => {
                            // console.log(value);
                            if (value && value.length) {
                                return QueryParam("w-in-raspredeleniePoKategoriyamTrek.poryadkoviiNomerVTure", value.map(e=>e.ID).join(","))
                            }
                            return ""
                        },
                        // filtered: 1,
                    })
                },
            ])}
            onCollectionChange={(collection) => {
                let track = _.first(collection);
                setTracks(collection)
                setCurrentTrack(track);
                // setIsPlaying(true);
            }}
            customRender={(items, {
                collection,
                setCollection,
                setCollectionItem,
                removeCollectionItem,
                collectionActions,
                modelActions,
                loading,
                update
            }) => (
                <div>
                    <Spin spinning={loading}>
                        <div className='scrollable' style={{ width: "100%" /*backgroundColor: "white"*/ }}>
                            <table className="xtable" style={{ fontSize: "13px", lineHeight: "normal" }}>
                                <thead>
                                    <tr>
                                        <th className={`fixed height-4`} style={{ minWidth: "555px", backgroundColor: "white" }} rowSpan={2}>
                                            <div className='bg bg-grey dark-1'></div>
                                        </th>

                                        <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }} colSpan={3}>
                                            <div className="bg bg-grey dark-1" style={{ backgroundColor: (true) ? getIndexColorLighter(9, 0.14) : "#f5f5f5" }}>
                                                Сложность 1
                                            </div>
                                        </th>
                                        <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }} colSpan={3}>
                                            <div className="bg bg-grey dark-1" style={{ backgroundColor: (true) ? getIndexColorLighter(10, 0.14) : "#f5f5f5" }}>
                                                Сложность 2
                                            </div>
                                        </th>
                                        <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }} colSpan={3}>
                                            <div className="bg bg-grey dark-1" style={{ backgroundColor: (true) ? getIndexColorLighter(11, 0.14) : "#f5f5f5" }}>
                                                Сложность 3
                                            </div>
                                        </th>
                                        <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }} colSpan={3}>
                                            <div className="bg bg-grey dark-1" style={{ backgroundColor: (true) ? getIndexColorLighter(17, 0.14) : "#f5f5f5" }}>
                                                Сложность 4
                                            </div>
                                        </th>
                                        <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }} colSpan={3}>
                                            <div className="bg bg-grey dark-1" style={{ backgroundColor: (true) ? getIndexColorLighter(13, 0.14) : "#f5f5f5" }}>
                                                Сложность 5
                                            </div>
                                        </th>

                                    </tr>
                                    <tr>
                                        <th className="height-4" style={{ width: "35px", minWidth: "35px", fontWeight: "300" }}>
                                            <div className="bg bg-grey dark-1" style={{ minWidth: "35px", backgroundColor: (true) ? getIndexColorLighter(9, 0.10) : "#f5f5f5" }}>
                                                О
                                            </div>
                                        </th>
                                        <th className="height-4" style={{ width: "35px", minWidth: "35px", fontWeight: "300" }}>
                                            <div className="bg bg-grey dark-1" style={{ minWidth: "35px", backgroundColor: (true) ? getIndexColorLighter(9, 0.14) : "#f5f5f5" }}>
                                                П
                                            </div>
                                        </th>
                                        <th className="height-4" style={{ width: "35px", minWidth: "35px", fontWeight: "300" }}>
                                            <div className="bg bg-grey dark-1" style={{ minWidth: "35px", backgroundColor: (true) ? getIndexColorLighter(9, 0.18) : "#f5f5f5" }}>
                                                Ф
                                            </div>
                                        </th>

                                        <th className="height-4" style={{ width: "35px", minWidth: "35px", fontWeight: "300" }}>
                                            <div className="bg bg-grey dark-1" style={{ minWidth: "35px", backgroundColor: (true) ? getIndexColorLighter(10, 0.10) : "#f5f5f5" }}>
                                                О
                                            </div>
                                        </th>
                                        <th className="height-4" style={{ width: "35px", minWidth: "35px", fontWeight: "300" }}>
                                            <div className="bg bg-grey dark-1" style={{ minWidth: "35px", backgroundColor: (true) ? getIndexColorLighter(10, 0.14) : "#f5f5f5" }}>
                                                П
                                            </div>
                                        </th>
                                        <th className="height-4" style={{ width: "35px", minWidth: "35px", fontWeight: "300" }}>
                                            <div className="bg bg-grey dark-1" style={{ minWidth: "35px", backgroundColor: (true) ? getIndexColorLighter(10, 0.18) : "#f5f5f5" }}>
                                                Ф
                                            </div>
                                        </th>

                                        <th className="height-4" style={{ width: "35px", minWidth: "35px", fontWeight: "300" }}>
                                            <div className="bg bg-grey dark-1" style={{ minWidth: "35px", backgroundColor: (true) ? getIndexColorLighter(11, 0.10) : "#f5f5f5" }}>
                                                О
                                            </div>
                                        </th>
                                        <th className="height-4" style={{ width: "35px", minWidth: "35px", fontWeight: "300" }}>
                                            <div className="bg bg-grey dark-1" style={{ minWidth: "35px", backgroundColor: (true) ? getIndexColorLighter(11, 0.14) : "#f5f5f5" }}>
                                                П
                                            </div>
                                        </th>
                                        <th className="height-4" style={{ width: "35px", minWidth: "35px", fontWeight: "300" }}>
                                            <div className="bg bg-grey dark-1" style={{ minWidth: "35px", backgroundColor: (true) ? getIndexColorLighter(11, 0.18) : "#f5f5f5" }}>
                                                Ф
                                            </div>
                                        </th>

                                        <th className="height-4" style={{ width: "35px", minWidth: "35px", fontWeight: "300" }}>
                                            <div className="bg bg-grey dark-1" style={{ minWidth: "35px", backgroundColor: (true) ? getIndexColorLighter(17, 0.10) : "#f5f5f5" }}>
                                                О
                                            </div>
                                        </th>
                                        <th className="height-4" style={{ width: "35px", minWidth: "35px", fontWeight: "300" }}>
                                            <div className="bg bg-grey dark-1" style={{ minWidth: "35px", backgroundColor: (true) ? getIndexColorLighter(17, 0.14) : "#f5f5f5" }}>
                                                П
                                            </div>
                                        </th>
                                        <th className="height-4" style={{ width: "35px", minWidth: "35px", fontWeight: "300" }}>
                                            <div className="bg bg-grey dark-1" style={{ minWidth: "35px", backgroundColor: (true) ? getIndexColorLighter(17, 0.18) : "#f5f5f5" }}>
                                                Ф
                                            </div>
                                        </th>

                                        <th className="height-4" style={{ width: "35px", minWidth: "35px", fontWeight: "300" }}>
                                            <div className="bg bg-grey dark-1" style={{ minWidth: "35px", backgroundColor: (true) ? getIndexColorLighter(13, 0.10) : "#f5f5f5" }}>
                                                О
                                            </div>
                                        </th>
                                        <th className="height-4" style={{ width: "35px", minWidth: "35px", fontWeight: "300" }}>
                                            <div className="bg bg-grey dark-1" style={{ minWidth: "35px", backgroundColor: (true) ? getIndexColorLighter(13, 0.14) : "#f5f5f5" }}>
                                                П
                                            </div>
                                        </th>
                                        <th className="height-4" style={{ width: "35px", minWidth: "35px", fontWeight: "300" }}>
                                            <div className="bg bg-grey dark-1" style={{ minWidth: "35px", backgroundColor: (true) ? getIndexColorLighter(13, 0.18) : "#f5f5f5" }}>
                                                Ф
                                            </div>
                                        </th>
                                    </tr>

                                </thead>
                                <tbody style={{ fontSize: "12px" }}>
                                    {JSXMap(items, (item, idx) => {
                                        return (<TrekPoKategoriyam key={item?.ID || idx} className={`bg ${(idx % 2 > 0) ? "bg-grey light-15" : "bg-fwhite"} pointer`} auth={auth} distsiplinaID={distsiplina} item={item} modelActions={modelActions} collection={collection} setCollection={setCollection} />)
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </Spin>
                </div>
            )}
            size={"small"}
            mode="list"
        />
    </div>)
}
function Sozdateli(props) {
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const auth = useAuth();
    const t = useTranslateContext();
    const user = useUserContext();
    const meta = useMetaContext();
    const [userConfig, setUserConfig] = useUserConfigContext();
    const siteAccess = useSelector(state => state.siteAccess.value);

    const filtersFromMeta = React.useCallback((name, funcs) => {
        let prop = [];
        // let p = _.get(meta[name], "properties");
        let p = GetMetaProperties(meta[name])
        p = deleteInProperties(p, ["CreatedAt", "UpdatedAt", "DeletedAt", "Creator", "Src", "Hash", "ID"])
        if (funcs) {
            for (let i = 0; i < funcs.length; i++) {
                const f = funcs[i];
                p = f(p);
            }
        }
        if (p) {
            prop = p?.filter(e => !_.get(e, "relation") || _.get(e, "relation.type") !== "one-many")?.map(e => ({ ...e, sort: true, filter: true, func: (e.filterType == "range") ? ["min", "max"] : undefined }))
        }
        return prop;
    }, [meta]);

    let metaTreki = _.get(meta, "Treki");
    let metaBazaSozdateleiTrekov = _.get(meta, "BazaSozdateleiTrekov");

    const bazaSozdateleiTrekovProperties = (obj, extarray) => {
        let r = [];
        let pr = obj.properties.filter(n => {
            return n.name !== "CreatedAt" && n.name !== "UpdatedAt" && n.name !== "DeletedAt" && n.name !== "Creator"
        })
        if (pr) {
            r.push(...pr)
        }
        r = updateInProperties(r, {
            label: "Страна",
            name: "Strana",
            type: "object",
            relation: {
                displayString: (item) => {
                    return item?.name
                },
                display: (item) => {
                    return (
                        <div>
                            <div>{item?.name}</div>
                            {/* <div style={{fontSize:"12px", color:"rgba(0,0,0,0.65)"}}>{item?.code}</div> */}
                        </div>
                    )
                },
                reference: { object: "Countries", property: "ID" },
                type: "many-one",
            },
            queryFilter: [
                // QueryDetail("model"),
                QueryOrder("name", "ASC")
            ],
        })
        return r
    }
    const cleanProperties = (obj, context, funcs) => {
        const { name, field, fieldName, contextObject, object } = context;
        if (!obj) { return obj }
        let p = GetMetaProperties(obj)
        p = deleteInProperties(p, ["CreatedAt", "UpdatedAt", "DeletedAt"])
        if (object && obj.type == "object") {
            p = updateInPropertiesUUID(p, {
                uuid: "object-owner-description",
                type: "func",
                render: () => (<ObjectOwnerDescription object={object} style={{ marginBottom: "5px" }} />)
            }, true)
        }
        if (contextObject && obj.type == "object" && field) {
            let fName = _.get(field, "relation.reference.property");
            let o = obj?.properties?.find(e => e.name == fName)
            if (o) {
                let oObj = _.get(o, "relation.reference.object");
                let oMeta = meta[oObj];
                p = updateInPropertiesUUID(p, {
                    uuid: "object-context-description",
                    type: "func",
                    render: () => (<div className='bg bg-grey' style={{ textAlign: "left", padding: "5px", marginBottom: "5px" }}>
                        {(oMeta) && <div style={{
                            fontSize: "10px",
                            color: "rgb(106, 106, 106)",
                            lineHeight: "10px",
                            fontStyle: "italic"
                        }}>{o?.label} ({oMeta?.label})</div>}
                        <div>{getObjectDisplay(contextObject, oObj, meta)}</div>
                        <div style={{ color: "#6a6a6a" }}><ObjectOwnerDescription object={contextObject} inline={true} /></div>
                    </div>)
                }, true)
            }
        }
        if (funcs) {
            for (let i = 0; i < funcs.length; i++) {
                const f = funcs[i];
                p = f(p);
            }
        }

        p = foreachInProperties(p, n => (n.name == "Kommentarii"), {
            type: "text"
        })
        p = foreachInProperties(p, n => (n.type == "object" && n.name == "TipDlyaTreka"), {
            relation: {
                displayString: (item) => {
                    return item?.nazvanie
                },
                display: (item) => {
                    return (
                        <div>{item?.nazvanie}</div>
                    )
                },
                reference: { object: "TipiDlyaTrekov", property: "ID" },
                type: "many-one",
            },
            queryFilter: [
                QueryDetail("collection"),
                QueryOrder("nazvanie", "ASC"),
            ],
        })
        p = foreachInProperties(p, n => (n.type == "object" && n.name == "RaspredeleniePoKategoriyamTrek"), (n) => {
            return ({
                queryFilter: [
                    QueryDetail("collection"),
                ],
                relation: {
                    ...n?.relation,
                    uiFilter: () => [],
                    displayString: (item) => {
                        return `${item?.distsiplina?.nazvanie} - ${item?.kategoriya?.nazvanie} Тур: ${item?.tur?.nazvanie}, Порядковый номер в туре: ${item?.poryadkoviiNomerVTure}, Сложность: ${item?.slozhnost}`
                    },
                    display: (item) => {
                        return (
                            <div>
                                <div style={{ fontSize: "12px", color: "rgba(0,0,0,0.65)" }}>
                                    {item?.distsiplina?.nazvanie} - {item?.kategoriya?.nazvanie}
                                </div>
                                <div>Тур: {item?.tur?.name}, Порядковый номер в туре: {item?.poryadkoviiNomerVTure}</div>
                                <div style={{ color: "rgba(0,0,0,0.65)" }}>Сложность: {item?.slozhnost}</div>
                            </div>
                        )
                    },
                },
            })
        })
        p = foreachInProperties(p, n => (n.type == "object" && n.name == "SozdateliTrekaTrek"), (n) => {
            return ({
                queryFilter: [
                    QueryDetail("collection"),
                    QueryOrder("sozdatel.familiya", "ASC"),
                ],
                relation: {
                    ...n?.relation,
                    uiFilter: () => [],
                    displayString: (item) => {
                        return `${item?.tipDlyaTreka?.nazvanie}: ${item?.sozdatel?.familiya} ${item?.sozdatel?.imya}${(item?.sozdatel?.psevdonim) ? " (" + item?.sozdatel?.psevdonim + ")" : ""}`
                    },
                    display: (item) => {
                        return (
                            <div>
                                <div style={{ fontSize: "12px", color: "rgba(0,0,0,0.65)" }}>{item?.tipDlyaTreka?.nazvanie}</div>
                                <div>{item?.sozdatel?.familiya} {item?.sozdatel?.imya}</div>
                            </div>
                        )
                    },
                },
            })
        })
        p = foreachInProperties(p, n => (n.type == "object" && n.name == "Sozdatel"), (n) => ({
            queryFilter: [
                QueryDetail("collection"),
                QueryOrder("familiya", "ASC"),
            ],
            relation: {
                ...n?.relation,
                displayString: (item) => {
                    return `${item?.familiya} ${item?.imya}${(item?.psevdonim) ? " (" + item?.psevdonim + ")" : ""}`
                },
                display: (item) => {
                    return (
                        <div>{item?.familiya} {item?.imya}</div>
                    )
                },
            },
            dropdownActions: () => [
                {
                    title: "Добавить создателя трека",
                    form: Model,
                    meta: [
                        {
                            label: "Фамилия",
                            name: "familiya",
                            type: "string",
                        },
                        {
                            label: "Имя",
                            name: "imya",
                            type: "string",
                        },
                        {
                            label: "Псевдоним",
                            name: "psevdonim",
                            type: "string",
                        },
                        {
                            label: "Страна",
                            name: "strana",
                            type: "object",
                            relation: {
                                displayString: (item) => {
                                    return item?.name
                                },
                                display: (item) => {
                                    return (
                                        <div>{item?.name}</div>
                                    )
                                },
                                reference: { object: "Countries", property: "ID" },
                                type: "many-one",
                            },
                            queryFilter: [
                                QueryOrder("name", "ASC")
                            ],
                        },
                    ],
                    action: (values, unlock, close, { collection, setCollection, apply }) => {
                        CREATE(auth, 'BazaSozdateleiTrekov', { ...values },
                            ({ data }) => {
                                setCollection(updateInArray(collection, data));
                                if (apply) {
                                    apply(data);
                                }
                                close();
                            },
                            (err) => errorCatch(err, unlock)
                        );
                    },
                },
            ]
        }))

        return SetMetaProperties(obj, p)
    }

    return (<CollectionServer
        auth={auth}
        name={"BazaSozdateleiTrekov"}
        filters={() => filtersFromMeta(metaBazaSozdateleiTrekov.name, [
            (p) => {
                return foreachInProperties(p, n => (n.name == "Strana"), {
                    display: (item) => {
                        return item?.name
                    },
                })
            }
        ])}
        customRender={(items, {
            collection,
            setCollection,
            setCollectionItem,
            removeCollectionItem,
            collectionActions,
            modelActions,
            update
        }) => (
            <div>
                {JSXMap(items, (item, idx) => {
                    return (
                        <div key={item?.ID || idx} className={`bg ${(idx % 2 > 0) ? "bg-grey light-15" : "bg-fwhite"} pointer`} style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "2px", textAlign: "left", padding: "0 5px" }}>
                            <div style={{ flex: "1 1 auto" }}>
                                <div>{item?.familiya} {item?.imya}</div>
                            </div>
                            <div style={{ flex: "0 0 25px" }}>
                                <DropdownAction
                                    style={{ padding: "0" }}
                                    button={() => (<div className={`pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                        <i className="fa fa-ellipsis-h"></i>
                                    </div>)}
                                    items={modelActions(item, idx)?.map((e, idx) => ({
                                        key: e.key || idx,
                                        auth: auth,
                                        mode: "MenuItem",
                                        object: item,
                                        collection: collection,
                                        setCollection: setCollection,
                                        ...e
                                    }))} />
                            </div>
                        </div>
                    )
                })}
            </div>
        )}
        size={"small"}
        mode="list"
        linksModelActions={"inline"}
        collectionActions={({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
            if (name === "BazaSozdateleiTrekov") {
                return [
                    {
                        auth: auth,
                        title: "Добавить",
                        modal: {
                            title: "Добавить создателя трека",
                        },
                        collectionActions: ({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                            return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject }) }))
                        },
                        modelActions: (item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                            return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }))
                        },
                        action: (values, unlock, close, { collection, setCollection, apply }) => {
                            CREATE(auth, 'BazaSozdateleiTrekov', { ...values },
                                ({ data }) => {
                                    setCollection(updateInArray(collection, data));
                                    if (apply) {
                                        apply(data);
                                    }
                                    close();
                                },
                                (err) => errorCatch(err, unlock)
                            );
                        },
                        modal: {
                            maskClosable: false,
                        },
                        form: Model,
                        meta: () => cleanProperties(bazaSozdateleiTrekovProperties(metaBazaSozdateleiTrekov), { name, field, fieldName, contextObject }),
                    }]
            }
            return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject }) }))
        }}
        modelActions={(item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
            if (name === "BazaSozdateleiTrekov") {
                return [
                    {
                        auth: auth,
                        title: "Изменить",
                        modal: {
                            title: "Изменить создателя трека",
                        },
                        object: item,
                        collectionActions: ({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
                            return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject }) }))
                        },
                        modelActions: (item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
                            return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }))
                        },
                        action: (values, unlock, close, { collection, setCollection, apply }) => {
                            UPDATE(auth, 'BazaSozdateleiTrekov', { ...values, ID: item.ID },
                                ({ data }) => {
                                    setCollection(updateInArray(collection, data));
                                    if (apply) {
                                        apply(data);
                                    }
                                    close();
                                },
                                (err) => errorCatch(err, unlock)
                            );
                        },
                        modal: {
                            maskClosable: false,
                        },
                        form: Model,
                        meta: () => cleanProperties(bazaSozdateleiTrekovProperties(metaBazaSozdateleiTrekov), { name, field, fieldName, contextObject, object: item }),
                    },
                    {
                        auth: auth,
                        title: <span style={{ color: "red" }}>Удалить</span>,
                        action: (values, unlock, close, { collection, setCollection }) => {
                            confirmKey({
                                pass: '123',
                                title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить создателя треков</span>,
                                icon: undefined,
                                content: <span>Вы действительно хотите удалить создателя треков?</span>,
                                okText: 'Удалить',
                                cancelText: 'Отмена',
                                onOk() {
                                    return new Promise((resolve, reject) => {
                                        GET(auth, '/api/query-delete/' + metaBazaSozdateleiTrekov.name.toLowerCase() + '/' + item.ID,
                                            ({ data }) => {
                                                setCollection(deleteInArray(collection, item));
                                                resolve(data);
                                            }, (err) => errorCatch(err, reject));
                                    }).catch(() => { });
                                },
                                onCancel() {
                                },
                            })

                        }
                    }]
            }
            return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }))
        }}
    />)
}

function ShabloniPleiListov(props) {
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const auth = useAuth();
    const t = useTranslateContext();
    const user = useUserContext();
    const meta = useMetaContext();
    const [userConfig, setUserConfig] = useUserConfigContext();
    const siteAccess = useSelector(state => state.siteAccess.value);

    const filtersFromMeta = React.useCallback((name, funcs) => {
        let prop = [];
        // let p = _.get(meta[name], "properties");
        let p = GetMetaProperties(meta[name])
        p = deleteInProperties(p, ["CreatedAt", "UpdatedAt", "DeletedAt", "Creator", "Src", "Hash", "ID", "Polzovatel", "User"])
        if (funcs) {
            for (let i = 0; i < funcs.length; i++) {
                const f = funcs[i];
                p = f(p);
            }
        }
        if (p) {
            prop = p?.filter(e => !_.get(e, "relation") || _.get(e, "relation.type") !== "one-many")?.map(e => ({ ...e, sort: true, filter: true, func: (e.filterType == "range") ? ["min", "max"] : undefined }))
        }
        return prop;
    }, [meta]);

    let metaShabloniPleiListov = _.get(meta, "ShabloniPleiListov");

    let metaDetalizatsiyaShablonovPleiListov = _.get(meta, "DetalizatsiyaShablonovPleiListov")

    const ShabloniPleiListovProperties = (obj, extarray) => {
        let r = [];
        let pr = obj.properties.filter(n => {
            return n.name !== "CreatedAt" && n.name !== "UpdatedAt" && n.name !== "DeletedAt" && n.name !== "Creator"
        })
        if (pr) {
            r.push(...pr)
        }

        return r
    }
    const cleanProperties = (obj, context, funcs) => {
        const { name, field, fieldName, contextObject, object } = context;
        if (!obj) { return obj }
        let p = GetMetaProperties(obj)
        p = deleteInProperties(p, ["CreatedAt", "UpdatedAt", "DeletedAt", "Polzovatel", "User"])
        if (object && obj.type == "object") {
            p = updateInPropertiesUUID(p, {
                uuid: "object-owner-description",
                type: "func",
                render: () => (<ObjectOwnerDescription object={object} style={{ marginBottom: "5px" }} />)
            }, true)
        }
        if (contextObject && obj.type == "object" && field) {
            let fName = _.get(field, "relation.reference.property");
            let o = obj?.properties?.find(e => e.name == fName)
            if (o) {
                let oObj = _.get(o, "relation.reference.object");
                let oMeta = meta[oObj];
                p = updateInPropertiesUUID(p, {
                    uuid: "object-context-description",
                    type: "func",
                    render: () => (<div className='bg bg-grey' style={{ textAlign: "left", padding: "5px", marginBottom: "5px" }}>
                        {(oMeta) && <div style={{
                            fontSize: "10px",
                            color: "rgb(106, 106, 106)",
                            lineHeight: "10px",
                            fontStyle: "italic"
                        }}>{o?.label} ({oMeta?.label})</div>}
                        <div>{getObjectDisplay(contextObject, oObj, meta)}</div>
                        <div style={{ color: "#6a6a6a" }}><ObjectOwnerDescription object={contextObject} inline={true} /></div>
                    </div>)
                }, true)
            }
        }
        if (funcs) {
            for (let i = 0; i < funcs.length; i++) {
                const f = funcs[i];
                p = f(p);
            }
        }

        p = foreachInProperties(p, n => (n.name == "Kommentarii"), {
            type: "text"
        })

        p = foreachInProperties(p, n => (n.type == "object" && n.name == "DetalizatsiyaShablonovPleiListovShablon"), (n) => {
            return ({
                // Для подчиненнх таблиц (табличных частей форм) установка детализации или сортировки через queryFilter не работает! Работает только установка полей "w-"
                // т.к. табличные части строятся при помощи CollectionByProperty для которого детализация задается через queryDetail, а сортировка через filters/uiFilter
                // queryFilter: [
                //     QueryDetail("collection"),
                //     QueryOrder("nomerVShablone", "ASC"),
                // ],
                relation: {
                    ...n?.relation,
                    reference: { ...n?.relation?.reference, source: "/api/detalizatsiyashablonovpleilistov/list" },
                    floatingFilter: true,
                    uiFilter: () => [
                        {
                            name: "nomerVShablone",
                            type: "int",
                            sort: true,
                            filter: true,
                            sorted: "ASC",
                        },
                    ],
                    displayString: (item) => {
                        return `${item?.nomerVShablone} ${item?.tantsevalnayaDistsiplina?.nazvanie}-${item?.kategoriya?.nazvanie} [${item?.kategoriya?.slozhnostKategorii}]`
                    },
                    display: (item) => {
                        return (
                            <div style={{ display: "flex", gap: "10px" }}>
                                <div className='bg bg-grey' style={{ flex: "0 0 40px" }}>{item?.nomerVShablone}</div>
                                <div style={{ flex: "1 1 auto" }}>
                                    <div>{item?.tantsevalnayaDistsiplina.nazvanie} - {item?.kategoriya.nazvanie} {item?.kategoriya?.slozhnostKategorii && <span>[{item?.kategoriya?.slozhnostKategorii}]</span>}</div>
                                    <div style={{ color: "rgba(0,0,0,0.65)" }}>
                                        {item?.otbor1KolichestvoZakhodov && <span><span>От1:</span> <span>{item?.otbor1KolichestvoZakhodov}/{item?.otbor1KolichestvoTrekovVZakhode}</span>, </span>}
                                        {item?.otbor2KolichestvoZakhodov && <span><span>От2:</span> <span>{item?.otbor2KolichestvoZakhodov}/{item?.otbor2KolichestvoTrekovVZakhode}</span>, </span>}
                                        {item?.otbor3KolichestvoZakhodov && <span><span>От3:</span> <span>{item?.otbor3KolichestvoZakhodov}/{item?.otbor3KolichestvoTrekovVZakhode}</span>, </span>}
                                        {item?.polufinalKolichestvoZakhodov && <span><span>Пф:</span> <span>{item?.polufinalKolichestvoZakhodov}/{item?.polufinalKolichestvoTrekovVZakhode}</span>, </span>}
                                        {item?.finalKolichestvoTrekovVZakhode && <span><span>Фин:</span> <span>{item?.finalKolichestvoTrekovVZakhode}</span></span>}
                                    </div>
                                </div>
                            </div>
                        )
                    },
                },
            })
        })

        return SetMetaProperties(obj, p)
    }

    const collectionActionsFunc = ({ mobject, name, field, fieldName, contextObject, collection, actions }) => {
        if (name === "ShabloniPleiListov") {
            return [
                {
                    auth: auth,
                    title: "Добавить",
                    modal: {
                        title: "Добавить шаблон плей листов",
                    },
                    collectionActions: collectionActionsFunc,
                    modelActions: modelActionsFunc,
                    action: (values, unlock, close, { collection, setCollection, apply }) => {
                        POST(auth, '/api/shablonipleilistov/new', { ...values },
                            ({ data }) => {
                                setCollection(updateInArray(collection, data));
                                if (apply) {
                                    apply(data);
                                }
                                close();
                            },
                            (err) => errorCatch(err, unlock)
                        );
                    },
                    modal: {
                        maskClosable: false,
                    },
                    form: Model,
                    meta: () => cleanProperties(ShabloniPleiListovProperties(metaShabloniPleiListov), { name, field, fieldName, contextObject }),
                }]
        }
        if (name === "DetalizatsiyaShablonovPleiListov") {
            return [
                {
                    auth: auth,
                    title: "Добавить",
                    modal: {
                        title: "Добавить детализацию шаблона",
                    },
                    collectionActions: collectionActionsFunc,
                    modelActions: modelActionsFunc,
                    action: (values, unlock, close, { collection, setCollection, apply }) => {
                        let f = (field?.relation?.reference?.property || "shablon") + "ID"
                        POST(auth, '/api/detalizatsiyashablonovpleilistov/new', { ...values, [f]: contextObject?.ID },
                            ({ data }) => {
                                setCollection(updateInArray(collection, data));
                                if (apply) {
                                    apply(data);
                                }
                                close();
                            },
                            (err) => errorCatch(err, unlock)
                        );
                    },
                    modal: {
                        maskClosable: false,
                    },
                    form: Model,
                    meta: () => cleanProperties(metaDetalizatsiyaShablonovPleiListov, { name, field, fieldName, contextObject }),
                }]
        }
        return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject }) }))
    }
    const modelActionsFunc = (item, index, { mobject, name, field, fieldName, contextObject, collection, actions }) => {
        if (name === "ShabloniPleiListov") {
            return [
                {
                    auth: auth,
                    title: "Изменить",
                    modal: {
                        title: "Изменить шаблон плей листов",
                    },
                    object: item,

                    links: "inline",
                    scheme: [
                        "DetalizatsiyaShablonovPleiListovShablon",
                    ],
                    collectionActions: collectionActionsFunc,
                    modelActions: modelActionsFunc,
                    action: (values, unlock, close, { collection, setCollection, apply }) => {
                        POST(auth, '/api/shablonipleilistov/update', { ...values, ID: item.ID },
                            ({ data }) => {
                                setCollection(updateInArray(collection, data));
                                if (apply) {
                                    apply(data);
                                }
                                close();
                            },
                            (err) => errorCatch(err, unlock)
                        );
                    },
                    modal: {
                        maskClosable: false,
                    },
                    form: Model,
                    meta: () => cleanProperties(ShabloniPleiListovProperties(metaShabloniPleiListov), { name, field, fieldName, contextObject, object: item }),
                },
                {
                    auth: auth,
                    title: <span style={{ color: "red" }}>Удалить</span>,
                    action: (values, unlock, close, { collection, setCollection }) => {
                        confirmKey({
                            pass: '123',
                            title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить шаблон плей листов</span>,
                            icon: undefined,
                            content: <span>Вы действительно хотите удалить шаблон плей листов?</span>,
                            okText: 'Удалить',
                            cancelText: 'Отмена',
                            onOk() {
                                return new Promise((resolve, reject) => {
                                    GET(auth, '/api/shablonipleilistov/delete/' + item.ID,
                                        ({ data }) => {
                                            setCollection(deleteInArray(collection, item));
                                            resolve(data);
                                        }, (err) => errorCatch(err, reject));
                                }).catch(() => { });
                            },
                            onCancel() {
                            },
                        })

                    }
                }]
        }
        if (name === "DetalizatsiyaShablonovPleiListov") {
            return [
                {
                    auth: auth,
                    title: "Изменить",
                    modal: {
                        title: "Изменить детализацию шаблона",
                    },
                    object: item,

                    links: "inline",
                    scheme: [
                        "DetalizatsiyaShablonovPleiListovShablon",
                    ],
                    collectionActions: collectionActionsFunc,
                    modelActions: modelActionsFunc,
                    action: (values, unlock, close, { collection, setCollection, apply }) => {
                        POST(auth, '/api/detalizatsiyashablonovpleilistov/update', { ...values, ID: item.ID },
                            ({ data }) => {
                                setCollection(updateInArray(collection, data));
                                if (apply) {
                                    apply(data);
                                }
                                close();
                            },
                            (err) => errorCatch(err, unlock)
                        );
                    },
                    modal: {
                        maskClosable: false,
                    },
                    form: Model,
                    meta: () => cleanProperties(metaDetalizatsiyaShablonovPleiListov, { name, field, fieldName, contextObject, object: item }),
                },
                {
                    auth: auth,
                    title: <span style={{ color: "red" }}>Удалить</span>,
                    action: (values, unlock, close, { collection, setCollection }) => {
                        confirmKey({
                            pass: '123',
                            title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить детализацию шаблона</span>,
                            icon: undefined,
                            content: <span>Вы действительно хотите удалить детализацию шаблона?</span>,
                            okText: 'Удалить',
                            cancelText: 'Отмена',
                            onOk() {
                                return new Promise((resolve, reject) => {
                                    GET(auth, '/api/detalizatsiyashablonovpleilistov/delete/' + item.ID,
                                        ({ data }) => {
                                            setCollection(deleteInArray(collection, item));
                                            resolve(data);
                                        }, (err) => errorCatch(err, reject));
                                }).catch(() => { });
                            },
                            onCancel() {
                            },
                        })

                    }
                }]
        }
        return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }))
    }

    return (<CollectionServer
        auth={auth}
        name={"ShabloniPleiListov"}
        source={`/api/shablonipleilistov/list`}
        filters={() => filtersFromMeta(metaShabloniPleiListov.name, [
            // (p) => {
            //     return foreachInProperties(p, n => (n.name == "Strana"), {
            //         display: (item) => {
            //             return item?.name
            //         },
            //     })
            // }
        ])}
        customRender={(items, {
            collection,
            setCollection,
            setCollectionItem,
            removeCollectionItem,
            collectionActions,
            modelActions,
            update
        }) => (
            <div>
                {JSXMap(items, (item, idx) => {
                    return (
                        <div key={item?.ID || idx} className={`bg ${(idx % 2 > 0) ? "bg-grey light-15" : "bg-fwhite"} pointer`} style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "2px", textAlign: "left", padding: "0 5px" }}>
                            <div style={{ flex: "1 1 auto" }}>
                                <div>{item?.nazvanie}</div>
                            </div>
                            <div style={{ flex: "0 0 25px" }}>
                                <DropdownAction
                                    style={{ padding: "0" }}
                                    button={() => (<div className={`pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                        <i className="fa fa-ellipsis-h"></i>
                                    </div>)}
                                    items={modelActions(item, idx)?.map((e, idx) => ({
                                        key: e.key || idx,
                                        auth: auth,
                                        mode: "MenuItem",
                                        object: item,
                                        collection: collection,
                                        setCollection: setCollection,
                                        ...e
                                    }))} />
                            </div>
                        </div>
                    )
                })}
            </div>
        )}
        size={"small"}
        mode="list"

        linksModelActions={"inline"}
        scheme={[
            "DetalizatsiyaShablonovPleiListovShablon",
        ]}

        collectionActions={collectionActionsFunc}
        modelActions={modelActionsFunc}
    />)
}

function TrekiVPleiListakhCollectionReplacement(props) {
    const { auth, collection, setCollection, modelActions, render, response, loading } = props;

    return (<div>
        <Spin spinning={loading}>
            <Card size="small" bordered={false} style={{ width: "100%" }}>
                {/* {response?.errorList && <div>
                    {JSXMap(response?.errorList, (item, idx) => {
                        return (<div>{item}</div>)
                    })}
                </div>} */}
                {!collection?.length && <div>
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Нет данных" />
                </div>}
                {(collection?.length > 0) && <div>
                    {JSXMap(collection, (item, idx) => {
                        return (<div key={item?.ID || idx} className={`bg ${(idx % 2 > 0) ? "bg-grey light-15" : "bg-fwhite"} pointer`} style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "2px", textAlign: "left" }}>
                            <div>{render(item, idx)}</div>
                            {(modelActions(item, idx)?.length) && <div style={{ flex: "0 0 25px", alignSelf: "start" }}>
                                <DropdownAction
                                    style={{ padding: "0" }}
                                    button={() => (<div className={`bg bg-fwhite pointer`} style={{ backgroundColor: "transparent", minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                        {/* <i className="fa fa-ellipsis-h"></i> */}
                                        <i className="fa fa-bars" style={{ fontSize: "11px" }} ></i>
                                    </div>)}
                                    items={modelActions(item, idx)?.map((e, idx) => ({
                                        key: e.key || idx,
                                        auth: auth,
                                        mode: "MenuItem",
                                        object: item,
                                        collection: collection,
                                        setCollection: setCollection,
                                        ...e
                                    }))} />
                            </div>}
                        </div>)
                    })}
                </div>}
            </Card>
        </Spin>
    </div>)
}

function DownloadOperationStatus(props) {
    const { auth, item, index, contextObject, collection, setCollection } = props;
    const [state, setState] = useState();
    const [error, setError] = useState();

    // playlist => "downloadUrl", "errorException", "errorMsg", "errorCode"
    // data, => "currentState", "errorList"

    const stop = useCallback(() => {
        confirmKey({
            pass: '123',
            title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Отменить формирование архива из плей-листа</span>,
            icon: undefined,
            content: <span>Вы действительно хотите отменить формирование архива из плей-листа?</span>,
            okText: 'Да, отменить',
            cancelText: 'Нет',
            onOk() {
                return new Promise((resolve, reject) => {
                    GET(auth, `/api/pleilisti/stopdownload/${item?.ID}`,
                        ({ data, currentState }) => {
                            setState(currentState);
                            if (!currentState) {
                                setCollection(updateInArray(collection, data))
                            }
                            resolve(data);
                        }, (err) => errorCatch(err, reject));
                }).catch(() => { });
            },
            onCancel() {
            },
        })
    }, [item])
    const refresh = useCallback(() => {
        GET(auth, `/api/pleilisti/statedownload/${item?.ID}`,
            ({ data, currentState }) => {
                setState(currentState);
                // console.log(data, currentState);
                if (!currentState) {
                    setCollection(updateInArray(collection, data))
                }

            }, (err) => errorCatch(err));
    }, [item])
    const build = useCallback(() => {
        GET(auth, `/api/pleilisti/download/${item?.ID}`,
            ({ data, currentState, errorList }) => {
                setState(currentState);
                setError(errorList)
                // console.log(data, currentState, errorList);
                if (!currentState) {
                    setCollection(updateInArray(collection, data))
                }
            }, (err) => errorCatch(err));
    }, [item])

    useEffect(() => {
        if (item?.ID) {
            refresh()
        }
    }, [item?.ID, item?.downloadUrl]);

    useEffect(() => {
        let interval = setInterval(() => {
            if (state) {
                refresh()
            }
        }, 2000);
        return () => clearInterval(interval);
    }, [state])

    return (<div style={{ marginTop: "10px" }}>

        {state && <div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "5px" }}>
                <div><Spin spinning={!!state} size='small' /></div>
                <div style={{
                    fontSize: "13px",
                    flex: "1 1 auto",
                    textWrap: "nowrap",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                }}>{state?.progress}% - {state?.message} </div>
                <Button onClick={refresh} type='link' ghost size='small'><i className="fa fa-refresh"></i> Обновить</Button>
                <Button onClick={stop} type='link' ghost size='small' danger><i className="fa fa-stop-circle"></i> Отмена</Button>
            </div>
            <div>
                <Progress percent={state?.progress} status='active' showInfo={false} size={"small"} />
            </div>
        </div>}

        {!state && <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "5px" }}>
            <div><Button onClick={build}><i className="fa fa-upload"></i>{(item?.downloadUrl && !item?.errorCode) ? "Пересоздать архив с треками" : "Создать архив с треками"}</Button></div>
            <div>
                {(item?.downloadUrl && !item?.errorCode) && <Button type='primary' ghost onClick={() => {
                    let link = ycStorage(auth) + ycBucket(auth) + "/" + item?.downloadUrl;
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = link;
                    a.download = "";
                    a.click();
                    window.URL.revokeObjectURL(link);
                }}><i className="fa fa-cloud-download"></i> Скачать архив</Button>}
            </div>
        </div>}

        {(item?.errorCode > 0) && <div>
            {item?.errorMsg && <div style={{ color: "red" }}>{item?.errorMsg}</div>}
            {/* {item?.errorException && <div style={{color:"red"}}>{item?.errorException}</div>} */}
        </div>}
        {error && <div>
            {JSXMap(error, (item, idx) => {
                return (<Alert type='error' message={<div>{item}</div>} />)
            })}
        </div>}
    </div>)
}
function PleiListi(props) {
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const auth = useAuth();
    const t = useTranslateContext();
    const user = useUserContext();
    const meta = useMetaContext();
    const [userConfig, setUserConfig] = useUserConfigContext();
    const siteAccess = useSelector(state => state.siteAccess.value);

    const filtersFromMeta = React.useCallback((name, funcs) => {
        let prop = [];
        let p = GetMetaProperties(meta[name])
        p = deleteInProperties(p, ["CreatedAt", "UpdatedAt", "DeletedAt", "Creator", "Src", "Hash", "ID", "Polzovatel", "User", "DownloadUrl"])
        if (funcs) {
            for (let i = 0; i < funcs.length; i++) {
                const f = funcs[i];
                p = f(p);
            }
        }
        if (p) {
            prop = p?.filter(e => !_.get(e, "relation") || _.get(e, "relation.type") !== "one-many")?.map(e => ({ ...e, sort: true, filter: true, func: (e.filterType == "range") ? ["min", "max"] : undefined }))
        }
        return prop;
    }, [meta]);

    let metaPleilisti = _.get(meta, "Pleilisti");
    let metaTrekiVPleiListakh = _.get(meta, "TrekiVPleiListakh");

    const PleilistiProperties = (obj, pro) => {
        const { item, index, contextObject, collection, setCollection } = pro;

        let r = [];
        let pr = obj.properties.filter(n => {
            return n.name !== "CreatedAt" && n.name !== "UpdatedAt" && n.name !== "DeletedAt" && n.name !== "Creator"
        })
        if (pr) {
            r.push(...pr)
        }

        if (item) {
            r = updateInPropertiesUUID(r, {
                uuid: "playlist-status",
                type: "func",
                render: () => {
                    return (<DownloadOperationStatus auth={auth} {...pro} />)
                }
            })
        }

        return r
    }
    const cleanProperties = (obj, context, funcs) => {
        const { name, field, fieldName, contextObject, object } = context;
        if (!obj) { return obj }
        let p = GetMetaProperties(obj)
        p = deleteInProperties(p, ["CreatedAt", "UpdatedAt", "DeletedAt", "Polzovatel", "User", "DownloadUrl", "LastError", "ErrorException", "ErrorMsg", "ErrorCode", "PleiList",])
        if (object && obj.type == "object") {
            p = updateInPropertiesUUID(p, {
                uuid: "object-owner-description",
                type: "func",
                render: () => (<ObjectOwnerDescription object={object} style={{ marginBottom: "5px" }} />)
            }, true)
        }
        if (contextObject && obj.type == "object" && field) {
            let fName = _.get(field, "relation.reference.property");
            let o = obj?.properties?.find(e => e.name == fName)
            if (o) {
                let oObj = _.get(o, "relation.reference.object");
                let oMeta = meta[oObj];
                p = updateInPropertiesUUID(p, {
                    uuid: "object-context-description",
                    type: "func",
                    render: () => (<div className='bg bg-grey' style={{ textAlign: "left", padding: "5px", marginBottom: "5px" }}>
                        {(oMeta) && <div style={{
                            fontSize: "10px",
                            color: "rgb(106, 106, 106)",
                            lineHeight: "10px",
                            fontStyle: "italic"
                        }}>{o?.label} ({oMeta?.label})</div>}
                        <div>{getObjectDisplay(contextObject, oObj, meta)}</div>
                        <div style={{ color: "#6a6a6a" }}><ObjectOwnerDescription object={contextObject} inline={true} /></div>
                    </div>)
                }, true)
            }
        }
        if (funcs) {
            for (let i = 0; i < funcs.length; i++) {
                const f = funcs[i];
                p = f(p);
            }
        }

        p = foreachInProperties(p, n => (n.name == "Kommentarii"), {
            type: "text"
        })

        p = foreachInProperties(p, n => (n.type == "object" && n.name == "Shablon"), {
            name: "Shablon",
            type: "object",
            label: "Шаблон",
            relation: {
                type: "many-one",
                reference: {
                    source: "/api/shablonipleilistov/list",
                    object: "ShabloniPleiListov",
                    property: "ID"
                },
                displayString: (item) => {
                    return item?.nazvanie
                },
                display: (item) => {
                    return (
                        <div>{item?.nazvanie}</div>
                    )
                },
            },
            "validators": {
                "required": false,
                "min": null,
                "max": null,
                "pattern": null
            },
            queryFilter: [
                QueryDetail("collection"),
                QueryOrder("nazvanie", "ASC"),
            ],
        })

        p = foreachInProperties(p, n => (n.type == "object" && n.name == "TrekiVPleiListakhPleiList"), (n) => {
            // let f = (field?.relation?.reference?.property || "pleiList") + "ID"
            return ({
                // Для подчиненнх таблиц (табличных частей форм) установка детализации или сортировки через queryFilter не работает! Работает только установка полей "w-"
                // т.к. табличные части строятся при помощи CollectionByProperty для которого детализация задается через queryDetail, а сортировка через filters/uiFilter
                // queryFilter: [
                //     QueryDetail("collection"),
                //     QueryOrder("nomerVPleiListe", "ASC"),
                // ],
                relation: {
                    ...n?.relation,
                    reference: { ...n?.relation?.reference, source: `/api/pleilisti/treki/${object?.ID}` },
                    floatingFilter: true,
                    uiFilter: () => [
                        {
                            name: "nomerVPleiListe",
                            type: "int",
                            sort: true,
                            filter: true,
                            sorted: "ASC",
                        },
                    ],
                    displayString: (item) => {
                        return `${item?.nomerVPleiListe} ${item?.tantsevalnayaDistsiplina?.nazvanie}-${item?.kategoriya?.nazvanie} [${item?.kategoriya?.slozhnostKategorii}]`
                    },
                    display: (item) => {
                        let idx = 1;
                        return (
                            <div style={{ display: "flex", gap: "8px" }}>
                                <div className='bg bg-grey' style={{ flex: "0 0 35px", minWidth: "35px", backgroundColor: getIndexColorLighter(item?.turID || 1, 0.15) }}>
                                    <div className='bg bg-fwhite' style={{ minWidth: "25px", margin: "2px" }}>{item?.nomerVPleiListe}</div>
                                    {(item?.turID && item?.turID == 1) && <div style={{ fontSize: "10px", color: "rgba(0,0,0,0.65)" }}>От {item?.nomerOtbora}</div>}
                                    {(item?.turID && item?.turID == 2) && <div style={{ fontSize: "10px", color: "rgba(0,0,0,0.65)" }}>Пф</div>}
                                    {(item?.turID && item?.turID == 3) && <div style={{ fontSize: "10px", color: "rgba(0,0,0,0.65)" }}>Фин</div>}
                                    {(item?.zakhod && item?.nomerVZakhode) && <div style={{ fontSize: "10px", color: "rgba(0,0,0,0.65)" }}>{item?.zakhod}/{item?.nomerVZakhode}</div>}
                                </div>
                                <div style={{ flex: "1 1 auto" }}>
                                    <TrekVPleiListakh className={`bg bg-fwhite pointer`} style={{ backgroundColor: "transparent" }} auth={auth} item={item?.trek} />
                                    <div style={{ fontSize: "12px", color: "rgba(0,0,0,0.65)" }}>{item?.tantsevalnayaDistsiplina.nazvanie} - {item?.kategoriya.nazvanie} {item?.kategoriya?.slozhnostKategorii && <span>[{item?.kategoriya?.slozhnostKategorii}]</span>}</div>
                                    {/* <div style={{ color: "rgba(0,0,0,0.65)" }}>
                                        {item?.otbor1KolichestvoZakhodov && <span><span>От1:</span> <span>{item?.otbor1KolichestvoZakhodov}/{item?.otbor1KolichestvoTrekovVZakhode}</span>, </span>}
                                        {item?.otbor2KolichestvoZakhodov && <span><span>От2:</span> <span>{item?.otbor2KolichestvoZakhodov}/{item?.otbor2KolichestvoTrekovVZakhode}</span>, </span>}
                                        {item?.otbor3KolichestvoZakhodov && <span><span>От3:</span> <span>{item?.otbor3KolichestvoZakhodov}/{item?.otbor3KolichestvoTrekovVZakhode}</span>, </span>}
                                        {item?.polufinalKolichestvoZakhodov && <span><span>Пф:</span> <span>{item?.polufinalKolichestvoZakhodov}/{item?.polufinalKolichestvoTrekovVZakhode}</span>, </span>}
                                        {item?.finalKolichestvoTrekovVZakhode && <span><span>Фин:</span> <span>{item?.finalKolichestvoTrekovVZakhode}</span></span>}
                                    </div> */}
                                </div>
                            </div>
                        )
                    },
                },
            })
        })

        p = foreachInProperties(p, n => (n.type == "object" && n.name == "Trek"), (n) => {
            // let f = (field?.relation?.reference?.property || "trek") + "ID"
            let metaTreki = _.get(meta, "Treki");
            return ({
                // Для подчиненнх таблиц (табличных частей форм) установка детализации или сортировки через queryFilter не работает! Работает только установка полей "w-"
                // т.к. табличные части строятся при помощи CollectionByProperty для которого детализация задается через queryDetail, а сортировка через filters/uiFilter
                // queryFilter: [
                //     QueryDetail("collection"),
                //     QueryOrder("nomerVPleiListe", "ASC"),
                // ],
                mode: "dialog",
                modal: { width: "610px" },
                relation: {
                    ...n?.relation,
                    reference: { ...n?.relation?.reference, source: `/api/treki/list` },
                    floatingFilter: true,
                    uiFilter: () => filtersFromMeta(metaTreki.name),
                    displayString: (item) => {
                        return `${item?.nazvanieTreka} - ${item?.sozdateliTrekaTrek?.map((sitem, idx) => {
                            return ((idx > 0) ? ", " : "") + sitem?.sozdatel?.familiya + " " + sitem?.sozdatel?.imya + ((sitem?.sozdatel?.psevdonim) ? " (" + sitem?.sozdatel?.psevdonim + ")" : "")
                        })}`
                    },
                    display: (item) => {
                        let idx = 1;
                        return (
                            <div style={{ display: "flex", gap: "8px" }}>
                                {/* <div className='bg bg-grey' style={{ flex: "0 0 35px", minWidth: "35px", backgroundColor: getIndexColorLighter(item?.turID || 1, 0.15) }}>
                                    <div className='bg bg-fwhite' style={{ minWidth: "25px", margin: "2px" }}>{item?.nomerVPleiListe}</div>
                                    {(item?.turID && item?.turID == 1) && <div style={{ fontSize: "10px", color: "rgba(0,0,0,0.65)" }}>От {item?.nomerOtbora}</div>}
                                    {(item?.turID && item?.turID == 2) && <div style={{ fontSize: "10px", color: "rgba(0,0,0,0.65)" }}>Пф</div>}
                                    {(item?.turID && item?.turID == 3) && <div style={{ fontSize: "10px", color: "rgba(0,0,0,0.65)" }}>Фин</div>}
                                    {(item?.zakhod && item?.nomerVZakhode) && <div style={{ fontSize: "10px", color: "rgba(0,0,0,0.65)" }}>{item?.zakhod}/{item?.nomerVZakhode}</div>}
                                </div> */}
                                <div style={{ flex: "1 1 auto" }}>
                                    <TrekVPleiListakh className={`bg bg-fwhite pointer`} style={{ backgroundColor: "transparent" }} auth={auth} item={item} />
                                    {/* <div style={{ fontSize: "12px", color: "rgba(0,0,0,0.65)" }}>{item?.tantsevalnayaDistsiplina.nazvanie} - {item?.kategoriya.nazvanie} {item?.kategoriya?.slozhnostKategorii && <span>[{item?.kategoriya?.slozhnostKategorii}]</span>}</div> */}
                                    {/* <div style={{ color: "rgba(0,0,0,0.65)" }}>
                                        {item?.otbor1KolichestvoZakhodov && <span><span>От1:</span> <span>{item?.otbor1KolichestvoZakhodov}/{item?.otbor1KolichestvoTrekovVZakhode}</span>, </span>}
                                        {item?.otbor2KolichestvoZakhodov && <span><span>От2:</span> <span>{item?.otbor2KolichestvoZakhodov}/{item?.otbor2KolichestvoTrekovVZakhode}</span>, </span>}
                                        {item?.otbor3KolichestvoZakhodov && <span><span>От3:</span> <span>{item?.otbor3KolichestvoZakhodov}/{item?.otbor3KolichestvoTrekovVZakhode}</span>, </span>}
                                        {item?.polufinalKolichestvoZakhodov && <span><span>Пф:</span> <span>{item?.polufinalKolichestvoZakhodov}/{item?.polufinalKolichestvoTrekovVZakhode}</span>, </span>}
                                        {item?.finalKolichestvoTrekovVZakhode && <span><span>Фин:</span> <span>{item?.finalKolichestvoTrekovVZakhode}</span></span>}
                                    </div> */}
                                </div>
                            </div>
                        )
                    },
                },
            })
        })

        return SetMetaProperties(obj, p)
    }

    // "/api/trekivpleilistakhhandlers/byid/{id}"
    // "/api/trekivpleilistakhhandlers/new"
    // "/api/trekivpleilistakhhandlers/update"
    // "/api/trekivpleilistakhhandlers/delete/{id}"

    const collectionActionsFunc = ({ mobject, name, field, fieldName, contextObject, collection, setCollection, actions, update, lock, unlock }) => {
        if (name === "Pleilisti") {
            return [
                {
                    auth: auth,
                    title: "Добавить",
                    modal: {
                        title: "Добавить плей-лист",
                    },
                    collectionActions: collectionActionsFunc,
                    modelActions: modelActionsFunc,
                    action: (values, unlock, close, { collection, setCollection, apply }) => {
                        POST(auth, '/api/pleilisti/new', { ...values },
                            ({ data }) => {
                                setCollection(updateInArray(collection, data));
                                if (apply) {
                                    apply(data);
                                }
                                close();
                            },
                            (err) => errorCatch(err, unlock)
                        );
                    },
                    modal: {
                        maskClosable: false,
                    },
                    form: Model,
                    meta: () => cleanProperties(PleilistiProperties(metaPleilisti, { contextObject, collection, setCollection }), { name, field, fieldName, contextObject }),
                }]
        }
        if (name === "TrekiVPleiListakh") {
            return [
                {
                    auth: auth,
                    title: "Добавить",
                    modal: {
                        title: "Добавить трек",
                    },
                    collectionActions: collectionActionsFunc,
                    modelActions: modelActionsFunc,
                    action: (values, unlock, close, { collection, setCollection, apply }) => {
                        let f = (field?.relation?.reference?.property || "shablon") + "ID"
                        POST(auth, '/api/trekivpleilistakhhandlers/new', { ...values, [f]: contextObject?.ID },
                            ({ data }) => {
                                setCollection(updateInArray(collection, data));
                                if (apply) {
                                    apply(data);
                                }
                                close();
                            },
                            (err) => errorCatch(err, unlock)
                        );
                    },
                    modal: {
                        maskClosable: false,
                    },
                    form: Model,
                    meta: () => cleanProperties(metaTrekiVPleiListakh, { name, field, fieldName, contextObject }),
                },
                ...((!collection?.length) ? [{
                    auth: auth,
                    title: <span>Создать по шаблону</span>,
                    action: (values, unlock, close, { collection, setCollection }) => {
                        GET(auth, '/api/pleilisti/build-by-template/' + contextObject.ID,
                            ({ data }) => {
                                update();
                            }, (err) => errorCatch(err, () => { }));
                    }
                }] : [{
                    auth: auth,
                    // mode: "text",
                    triggerOptions: {
                        danger: "true"
                    },
                    title: <span style={{ color: "red" }}><i className="fa fa-trash" ></i> Очистить</span>,
                    action: (values, unlock, close, { collection, setCollection }) => {
                        confirmKey({
                            pass: '123',
                            title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить треки из плей-листа</span>,
                            icon: undefined,
                            content: <span>Вы действительно хотите удалить треки из плей-листа?</span>,
                            okText: 'Удалить',
                            cancelText: 'Отмена',
                            onOk() {
                                return new Promise((resolve, reject) => {
                                    GET(auth, '/api/pleilisti/clear-all-tracks-by-playlistid/' + contextObject.ID,
                                        ({ data }) => {
                                            setCollection(undefined);
                                            resolve(data);
                                        }, (err) => errorCatch(err, reject));
                                }).catch(() => { });
                            },
                            onCancel() {
                            },
                        })

                    }
                }])
            ]
        }
        return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject, collection, setCollection }) }))
    }
    const modelActionsFunc = (item, index, { mobject, name, field, fieldName, contextObject, collection, setCollection, actions }) => {
        if (name === "Pleilisti") {
            return [
                {
                    auth: auth,
                    title: "Изменить",
                    modal: {
                        title: "Изменить плей-лист",
                    },
                    object: item,

                    links: "inline",
                    scheme: [
                        "TrekiVPleiListakhPleiList",
                    ],
                    collectionActions: collectionActionsFunc,
                    modelActions: modelActionsFunc,
                    action: (values, unlock, close, { collection, setCollection, apply }) => {
                        POST(auth, '/api/pleilisti/update', { ...values, ID: item.ID },
                            ({ data }) => {
                                setCollection(updateInArray(collection, data));
                                if (apply) {
                                    apply(data);
                                }
                                close();
                            },
                            (err) => errorCatch(err, unlock)
                        );
                    },
                    modal: {
                        maskClosable: false,
                        width: "680px"
                    },
                    form: Model,
                    meta: () => cleanProperties(PleilistiProperties(metaPleilisti, { item, index, contextObject, collection, setCollection }), { name, field, fieldName, contextObject, object: item }),
                },
                ...((item?.downloadUrl && !item?.errorCode) ? [{
                    auth: auth,
                    title: <span style={{ color: "blue" }}>Скачать</span>,
                    action: (values, unlock, close, { collection, setCollection }) => {
                        let link = ycStorage(auth) + ycBucket(auth) + "/" + item?.downloadUrl;
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = link;
                        a.download = "";//item?.nazvanie+".zip";
                        a.click();
                        window.URL.revokeObjectURL(link);
                    }
                }] : []),
                {
                    auth: auth,
                    title: <span style={{ color: "red" }}>Удалить</span>,
                    action: (values, unlock, close, { collection, setCollection }) => {
                        confirmKey({
                            pass: '123',
                            title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить плей-лист</span>,
                            icon: undefined,
                            content: <span>Вы действительно хотите удалить плей-лист?</span>,
                            okText: 'Удалить',
                            cancelText: 'Отмена',
                            onOk() {
                                return new Promise((resolve, reject) => {
                                    GET(auth, '/api/pleilisti/delete/' + item.ID,
                                        ({ data }) => {
                                            setCollection(deleteInArray(collection, item));
                                            resolve(data);
                                        }, (err) => errorCatch(err, reject));
                                }).catch(() => { });
                            },
                            onCancel() {
                            },
                        })

                    }
                }]
        }
        // if (name === "TrekiVPleiListakh") {
        //     return []
        // }
        if (name === "TrekiVPleiListakh") {
            return [
                {
                    auth: auth,
                    title: "Изменить",
                    modal: {
                        title: "Изменить трек",
                    },
                    object: item,

                    links: "inline",
                    scheme: [
                        "Trek",
                    ],
                    collectionActions: collectionActionsFunc,
                    modelActions: modelActionsFunc,
                    action: (values, unlock, close, { collection, setCollection, apply }) => {
                        POST(auth, '/api/trekivpleilistakhhandlers/update', { ...values, ID: item.ID },
                            ({ data }) => {
                                setCollection(updateInArray(collection, data));
                                if (apply) {
                                    apply(data);
                                }
                                close();
                            },
                            (err) => errorCatch(err, unlock)
                        );
                    },
                    modal: {
                        maskClosable: false,
                    },
                    form: Model,
                    meta: () => cleanProperties(metaTrekiVPleiListakh, { name, field, fieldName, contextObject, object: item, collection, setCollection }),
                },
                {
                    auth: auth,
                    title: <span style={{ color: "red" }}>Удалить</span>,
                    action: (values, unlock, close, { collection, setCollection }) => {
                        confirmKey({
                            pass: '123',
                            title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить трек</span>,
                            icon: undefined,
                            content: <span>Вы действительно хотите удалить трек?</span>,
                            okText: 'Удалить',
                            cancelText: 'Отмена',
                            onOk() {
                                return new Promise((resolve, reject) => {
                                    GET(auth, '/api/trekivpleilistakhhandlers/delete/' + item.ID,
                                        ({ data }) => {
                                            setCollection(deleteInArray(collection, item));
                                            resolve(data);
                                        }, (err) => errorCatch(err, reject));
                                }).catch(() => { });
                            },
                            onCancel() {
                            },
                        })

                    }
                }]
        }
        return actions.map(e => ({ ...e, meta: cleanProperties(mobject, { name, field, fieldName, contextObject, object: item }) }))
    }

    if (!metaPleilisti) return (<React.Fragment></React.Fragment>)
    return (<CollectionPartialReplacementProvider initial={{ "TrekiVPleiListakh": TrekiVPleiListakhCollectionReplacement }}>
        <CollectionServer
            auth={auth}
            name={"Pleilisti"}
            source={`/api/pleilisti/list`}
            filters={() => filtersFromMeta(metaPleilisti.name, [
                // (p) => {
                //     return foreachInProperties(p, n => (n.name == "Strana"), {
                //         display: (item) => {
                //             return item?.name
                //         },
                //     })
                // }
            ])}
            customRender={(items, {
                collection,
                setCollection,
                setCollectionItem,
                removeCollectionItem,
                collectionActions,
                modelActions,
                update,
                response
            }) => (
                <div>
                    {JSXMap(items, (item, idx) => {
                        return (
                            <div key={item?.ID || idx} className={`bg ${(idx % 2 > 0) ? "bg-grey light-15" : "bg-fwhite"} pointer`} style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "2px", textAlign: "left", padding: "0 5px" }}>
                                <div style={{ flex: "1 1 auto" }}>
                                    <div>{item?.nazvanie}</div>
                                </div>
                                <div style={{ flex: "0 0 25px" }}>
                                    <DropdownAction
                                        style={{ padding: "0" }}
                                        button={() => (<div className={`pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                            <i className="fa fa-ellipsis-h"></i>
                                        </div>)}
                                        items={modelActions(item, idx)?.map((e, idx) => ({
                                            key: e.key || idx,
                                            auth: auth,
                                            mode: "MenuItem",
                                            object: item,
                                            collection: collection,
                                            setCollection: setCollection,
                                            ...e
                                        }))} />
                                </div>
                            </div>
                        )
                    })}
                </div>
            )}
            size={"small"}
            mode="list"
            linksModelActions={"inline"}
            scheme={[
                "TrekiVPleiListakhPleiList"
            ]}
            collectionActions={collectionActionsFunc}
            modelActions={modelActionsFunc}
        />
    </CollectionPartialReplacementProvider>)
}

export default function Music(props) {
    let { id } = useParams();
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const auth = useAuth();
    const t = useTranslateContext();
    const user = useUserContext();
    const meta = useMetaContext();
    const [userConfig, setUserConfig] = useUserConfigContext();
    const siteAccess = useSelector(state => state.siteAccess.value);

    let metaTreki = _.get(meta, "Treki");

    // "/api/detalizatsiyashablonovpleilistov/byid/{id}"
    // "/api/detalizatsiyashablonovpleilistov/list"
    // "/api/detalizatsiyashablonovpleilistov/new"
    // "/api/detalizatsiyashablonovpleilistov/update"
    // "/api/detalizatsiyashablonovpleilistov/delete/{id}"

    return (
        <PageLayout hideSider={true} hideBreadcrumbs={true}>
            <AudioPlayerProvider>
                <div style={{ margin: "0 10px" }}>
                    <div style={{ marginTop: "10px" }}>
                        <AudioPlayer />
                    </div>
                    <Tabs defaultActiveKey="treki">
                        <Tabs.TabPane tab={"База треков"} key="treki">
                            {(metaTreki) && <Treki />}
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="Треки по категориям" key="RaspredeleniePoKategoriyam">
                            {(metaTreki) && <RaspredeleniePoKategoriyam />}
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="Создатели" key="sozdateli">
                            <Sozdateli />
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="Шаблоны плей листов" key="shablonipleilistov">
                            <ShabloniPleiListov />
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="Плей-лист" key="pleilisti">
                            <PleiListi />
                        </Tabs.TabPane>
                    </Tabs>
                </div>
            </AudioPlayerProvider>
        </PageLayout>
    );
    // return (
    //     <div>
    //         <MenuLevelTwoContext.Provider value={menu(status, notify)}>
    //             {(!siteAccess || siteAccess == "allow") && <Routes>
    //                 {defaultRoute(menu(status, notify), role_by_id)}
    //                 {menu(status, notify).map((e, idx) => {
    //                     if (e.component && access(e, role_by_id)) {
    //                         return <Route key={e.uuid} path={(e.uuid !== "*")?e.uuid + "/*":"*"} element={
    //                             <BreadcrumbsProvider value={{
    //                                 // parent: props?.level,
    //                                 uuid: e?.uuid,
    //                                 name: e?.name,
    //                                 color: e?.color,
    //                                 role: e?.role,
    //                                 hidden: e.hidden
    //                             }}>
    //                                 {e.component({})}
    //                             </BreadcrumbsProvider>}
    //                         />
    //                     }
    //                 })}
    //             </Routes>}
    //         </MenuLevelTwoContext.Provider>
    //     </div>
    // );
}
